// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (modules, entry, mainEntry, parcelRequireName, globalName) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        globalObject
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      return res === false ? {} : newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });

      // <script>
    } else if (globalName) {
      this[globalName] = mainExports;
    }
  }
})({"2KbAe":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _preview = require("./dist/preview");
parcelHelpers.exportAll(_preview, exports);

},{"./dist/preview":"gMilg","@parcel/transformer-js/src/esmodule-helpers.js":"diccK"}],"gMilg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "argsEnhancers", ()=>argsEnhancers);
parcelHelpers.export(exports, "parameters", ()=>parameters);
parcelHelpers.export(exports, "runStep", ()=>runStep);
var _previewApi = require("@storybook/preview-api");
var _global = require("@storybook/global");
var _coreEvents = require("@storybook/core-events");
var _clientLogger = require("@storybook/client-logger");
var _jestMock = require("jest-mock");
var Buffer = require("5da2f07b9fbb684").Buffer;
var process = require("c6663070f1932f32");
var __require = ((x)=>undefined)(function(x) {
    return undefined(this, arguments);
});
var __create = Object.create, __defProp = Object.defineProperty, __getOwnPropDesc = Object.getOwnPropertyDescriptor, __getOwnPropNames = Object.getOwnPropertyNames, __getProtoOf = Object.getPrototypeOf, __hasOwnProp = Object.prototype.hasOwnProperty, __require2 = ((x)=>typeof __require < "u" ? __require : typeof Proxy < "u" ? new Proxy(x, {
        get: (a, b)=>(typeof __require < "u" ? __require : a)[b]
    }) : x)(function(x) {
    if (typeof __require < "u") return __require.apply(this, arguments);
    throw Error('Dynamic require of "' + x + '" is not supported');
}), __commonJS = (cb, mod)=>function() {
        return mod || (0, cb[__getOwnPropNames(cb)[0]])((mod = {
            exports: {}
        }).exports, mod), mod.exports;
    }, __copyProps = (to, from, except, desc)=>{
    if (from && typeof from == "object" || typeof from == "function") for (let key of __getOwnPropNames(from))!__hasOwnProp.call(to, key) && key !== except && __defProp(to, key, {
        get: ()=>from[key],
        enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable
    });
    return to;
}, __toESM = (mod, isNodeMode, target)=>(target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", {
        value: mod,
        enumerable: !0
    }) : target, mod)), require_ansi_styles = __commonJS({
    "../../node_modules/pretty-format/node_modules/ansi-styles/index.js" (exports, module) {
        var wrapAnsi256 = (offset = 0)=>(code)=>`\x1B[${38 + offset};5;${code}m`, wrapAnsi16m = (offset = 0)=>(red, green, blue)=>`\x1B[${38 + offset};2;${red};${green};${blue}m`;
        function assembleStyles() {
            let codes = new Map, styles = {
                modifier: {
                    reset: [
                        0,
                        0
                    ],
                    bold: [
                        1,
                        22
                    ],
                    dim: [
                        2,
                        22
                    ],
                    italic: [
                        3,
                        23
                    ],
                    underline: [
                        4,
                        24
                    ],
                    overline: [
                        53,
                        55
                    ],
                    inverse: [
                        7,
                        27
                    ],
                    hidden: [
                        8,
                        28
                    ],
                    strikethrough: [
                        9,
                        29
                    ]
                },
                color: {
                    black: [
                        30,
                        39
                    ],
                    red: [
                        31,
                        39
                    ],
                    green: [
                        32,
                        39
                    ],
                    yellow: [
                        33,
                        39
                    ],
                    blue: [
                        34,
                        39
                    ],
                    magenta: [
                        35,
                        39
                    ],
                    cyan: [
                        36,
                        39
                    ],
                    white: [
                        37,
                        39
                    ],
                    blackBright: [
                        90,
                        39
                    ],
                    redBright: [
                        91,
                        39
                    ],
                    greenBright: [
                        92,
                        39
                    ],
                    yellowBright: [
                        93,
                        39
                    ],
                    blueBright: [
                        94,
                        39
                    ],
                    magentaBright: [
                        95,
                        39
                    ],
                    cyanBright: [
                        96,
                        39
                    ],
                    whiteBright: [
                        97,
                        39
                    ]
                },
                bgColor: {
                    bgBlack: [
                        40,
                        49
                    ],
                    bgRed: [
                        41,
                        49
                    ],
                    bgGreen: [
                        42,
                        49
                    ],
                    bgYellow: [
                        43,
                        49
                    ],
                    bgBlue: [
                        44,
                        49
                    ],
                    bgMagenta: [
                        45,
                        49
                    ],
                    bgCyan: [
                        46,
                        49
                    ],
                    bgWhite: [
                        47,
                        49
                    ],
                    bgBlackBright: [
                        100,
                        49
                    ],
                    bgRedBright: [
                        101,
                        49
                    ],
                    bgGreenBright: [
                        102,
                        49
                    ],
                    bgYellowBright: [
                        103,
                        49
                    ],
                    bgBlueBright: [
                        104,
                        49
                    ],
                    bgMagentaBright: [
                        105,
                        49
                    ],
                    bgCyanBright: [
                        106,
                        49
                    ],
                    bgWhiteBright: [
                        107,
                        49
                    ]
                }
            };
            styles.color.gray = styles.color.blackBright, styles.bgColor.bgGray = styles.bgColor.bgBlackBright, styles.color.grey = styles.color.blackBright, styles.bgColor.bgGrey = styles.bgColor.bgBlackBright;
            for (let [groupName, group] of Object.entries(styles)){
                for (let [styleName, style] of Object.entries(group))styles[styleName] = {
                    open: `\x1B[${style[0]}m`,
                    close: `\x1B[${style[1]}m`
                }, group[styleName] = styles[styleName], codes.set(style[0], style[1]);
                Object.defineProperty(styles, groupName, {
                    value: group,
                    enumerable: !1
                });
            }
            return Object.defineProperty(styles, "codes", {
                value: codes,
                enumerable: !1
            }), styles.color.close = "\x1B[39m", styles.bgColor.close = "\x1B[49m", styles.color.ansi256 = wrapAnsi256(), styles.color.ansi16m = wrapAnsi16m(), styles.bgColor.ansi256 = wrapAnsi256(10), styles.bgColor.ansi16m = wrapAnsi16m(10), Object.defineProperties(styles, {
                rgbToAnsi256: {
                    value: (red, green, blue)=>red === green && green === blue ? red < 8 ? 16 : red > 248 ? 231 : Math.round((red - 8) / 247 * 24) + 232 : 16 + 36 * Math.round(red / 255 * 5) + 6 * Math.round(green / 255 * 5) + Math.round(blue / 255 * 5),
                    enumerable: !1
                },
                hexToRgb: {
                    value: (hex)=>{
                        let matches = /(?<colorString>[a-f\d]{6}|[a-f\d]{3})/i.exec(hex.toString(16));
                        if (!matches) return [
                            0,
                            0,
                            0
                        ];
                        let { colorString } = matches.groups;
                        colorString.length === 3 && (colorString = colorString.split("").map((character)=>character + character).join(""));
                        let integer = Number.parseInt(colorString, 16);
                        return [
                            integer >> 16 & 255,
                            integer >> 8 & 255,
                            integer & 255
                        ];
                    },
                    enumerable: !1
                },
                hexToAnsi256: {
                    value: (hex)=>styles.rgbToAnsi256(...styles.hexToRgb(hex)),
                    enumerable: !1
                }
            }), styles;
        }
        Object.defineProperty(module, "exports", {
            enumerable: !0,
            get: assembleStyles
        });
    }
}), require_collections = __commonJS({
    "../../node_modules/pretty-format/build/collections.js" (exports) {
        Object.defineProperty(exports, "__esModule", {
            value: !0
        }), exports.printIteratorEntries = printIteratorEntries, exports.printIteratorValues = printIteratorValues, exports.printListItems = printListItems, exports.printObjectProperties = printObjectProperties;
        var getKeysOfEnumerableProperties = (object, compareKeys)=>{
            let rawKeys = Object.keys(object), keys = compareKeys !== null ? rawKeys.sort(compareKeys) : rawKeys;
            return Object.getOwnPropertySymbols && Object.getOwnPropertySymbols(object).forEach((symbol)=>{
                Object.getOwnPropertyDescriptor(object, symbol).enumerable && keys.push(symbol);
            }), keys;
        };
        function printIteratorEntries(iterator, config, indentation, depth, refs, printer, separator = ": ") {
            let result = "", width = 0, current = iterator.next();
            if (!current.done) {
                result += config.spacingOuter;
                let indentationNext = indentation + config.indent;
                for(; !current.done;){
                    if (result += indentationNext, width++ === config.maxWidth) {
                        result += "\u2026";
                        break;
                    }
                    let name = printer(current.value[0], config, indentationNext, depth, refs), value = printer(current.value[1], config, indentationNext, depth, refs);
                    result += name + separator + value, current = iterator.next(), current.done ? config.min || (result += ",") : result += `,${config.spacingInner}`;
                }
                result += config.spacingOuter + indentation;
            }
            return result;
        }
        function printIteratorValues(iterator, config, indentation, depth, refs, printer) {
            let result = "", width = 0, current = iterator.next();
            if (!current.done) {
                result += config.spacingOuter;
                let indentationNext = indentation + config.indent;
                for(; !current.done;){
                    if (result += indentationNext, width++ === config.maxWidth) {
                        result += "\u2026";
                        break;
                    }
                    result += printer(current.value, config, indentationNext, depth, refs), current = iterator.next(), current.done ? config.min || (result += ",") : result += `,${config.spacingInner}`;
                }
                result += config.spacingOuter + indentation;
            }
            return result;
        }
        function printListItems(list, config, indentation, depth, refs, printer) {
            let result = "";
            if (list.length) {
                result += config.spacingOuter;
                let indentationNext = indentation + config.indent;
                for(let i = 0; i < list.length; i++){
                    if (result += indentationNext, i === config.maxWidth) {
                        result += "\u2026";
                        break;
                    }
                    i in list && (result += printer(list[i], config, indentationNext, depth, refs)), i < list.length - 1 ? result += `,${config.spacingInner}` : config.min || (result += ",");
                }
                result += config.spacingOuter + indentation;
            }
            return result;
        }
        function printObjectProperties(val, config, indentation, depth, refs, printer) {
            let result = "", keys = getKeysOfEnumerableProperties(val, config.compareKeys);
            if (keys.length) {
                result += config.spacingOuter;
                let indentationNext = indentation + config.indent;
                for(let i = 0; i < keys.length; i++){
                    let key = keys[i], name = printer(key, config, indentationNext, depth, refs), value = printer(val[key], config, indentationNext, depth, refs);
                    result += `${indentationNext + name}: ${value}`, i < keys.length - 1 ? result += `,${config.spacingInner}` : config.min || (result += ",");
                }
                result += config.spacingOuter + indentation;
            }
            return result;
        }
    }
}), require_AsymmetricMatcher = __commonJS({
    "../../node_modules/pretty-format/build/plugins/AsymmetricMatcher.js" (exports) {
        Object.defineProperty(exports, "__esModule", {
            value: !0
        }), exports.test = exports.serialize = exports.default = void 0;
        var _collections = require_collections(), Symbol2 = globalThis["jest-symbol-do-not-touch"] || globalThis.Symbol, asymmetricMatcher = typeof Symbol2 == "function" && Symbol2.for ? Symbol2.for("jest.asymmetricMatcher") : 1267621, SPACE = " ", serialize = (val, config, indentation, depth, refs, printer)=>{
            let stringedValue = val.toString();
            if (stringedValue === "ArrayContaining" || stringedValue === "ArrayNotContaining") return ++depth > config.maxDepth ? `[${stringedValue}]` : `${stringedValue + SPACE}[${(0, _collections.printListItems)(val.sample, config, indentation, depth, refs, printer)}]`;
            if (stringedValue === "ObjectContaining" || stringedValue === "ObjectNotContaining") return ++depth > config.maxDepth ? `[${stringedValue}]` : `${stringedValue + SPACE}{${(0, _collections.printObjectProperties)(val.sample, config, indentation, depth, refs, printer)}}`;
            if (stringedValue === "StringMatching" || stringedValue === "StringNotMatching" || stringedValue === "StringContaining" || stringedValue === "StringNotContaining") return stringedValue + SPACE + printer(val.sample, config, indentation, depth, refs);
            if (typeof val.toAsymmetricMatcher != "function") throw new Error(`Asymmetric matcher ${val.constructor.name} does not implement toAsymmetricMatcher()`);
            return val.toAsymmetricMatcher();
        };
        exports.serialize = serialize;
        var test = (val)=>val && val.$$typeof === asymmetricMatcher;
        exports.test = test;
        var plugin = {
            serialize,
            test
        }, _default = plugin;
        exports.default = _default;
    }
}), require_DOMCollection = __commonJS({
    "../../node_modules/pretty-format/build/plugins/DOMCollection.js" (exports) {
        Object.defineProperty(exports, "__esModule", {
            value: !0
        }), exports.test = exports.serialize = exports.default = void 0;
        var _collections = require_collections(), SPACE = " ", OBJECT_NAMES = [
            "DOMStringMap",
            "NamedNodeMap"
        ], ARRAY_REGEXP = /^(HTML\w*Collection|NodeList)$/, testName = (name)=>OBJECT_NAMES.indexOf(name) !== -1 || ARRAY_REGEXP.test(name), test = (val)=>val && val.constructor && !!val.constructor.name && testName(val.constructor.name);
        exports.test = test;
        var isNamedNodeMap = (collection)=>collection.constructor.name === "NamedNodeMap", serialize = (collection, config, indentation, depth, refs, printer)=>{
            let name = collection.constructor.name;
            return ++depth > config.maxDepth ? `[${name}]` : (config.min ? "" : name + SPACE) + (OBJECT_NAMES.indexOf(name) !== -1 ? `{${(0, _collections.printObjectProperties)(isNamedNodeMap(collection) ? Array.from(collection).reduce((props, attribute)=>(props[attribute.name] = attribute.value, props), {}) : {
                ...collection
            }, config, indentation, depth, refs, printer)}}` : `[${(0, _collections.printListItems)(Array.from(collection), config, indentation, depth, refs, printer)}]`);
        };
        exports.serialize = serialize;
        var plugin = {
            serialize,
            test
        }, _default = plugin;
        exports.default = _default;
    }
}), require_escapeHTML = __commonJS({
    "../../node_modules/pretty-format/build/plugins/lib/escapeHTML.js" (exports) {
        Object.defineProperty(exports, "__esModule", {
            value: !0
        }), exports.default = escapeHTML;
        function escapeHTML(str) {
            return str.replace(/</g, "&lt;").replace(/>/g, "&gt;");
        }
    }
}), require_markup = __commonJS({
    "../../node_modules/pretty-format/build/plugins/lib/markup.js" (exports) {
        Object.defineProperty(exports, "__esModule", {
            value: !0
        }), exports.printText = exports.printProps = exports.printElementAsLeaf = exports.printElement = exports.printComment = exports.printChildren = void 0;
        var _escapeHTML = _interopRequireDefault(require_escapeHTML());
        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                default: obj
            };
        }
        var printProps = (keys, props, config, indentation, depth, refs, printer)=>{
            let indentationNext = indentation + config.indent, colors = config.colors;
            return keys.map((key)=>{
                let value = props[key], printed = printer(value, config, indentationNext, depth, refs);
                return typeof value != "string" && (printed.indexOf(`
`) !== -1 && (printed = config.spacingOuter + indentationNext + printed + config.spacingOuter + indentation), printed = `{${printed}}`), `${config.spacingInner + indentation + colors.prop.open + key + colors.prop.close}=${colors.value.open}${printed}${colors.value.close}`;
            }).join("");
        };
        exports.printProps = printProps;
        var printChildren = (children, config, indentation, depth, refs, printer)=>children.map((child)=>config.spacingOuter + indentation + (typeof child == "string" ? printText(child, config) : printer(child, config, indentation, depth, refs))).join("");
        exports.printChildren = printChildren;
        var printText = (text, config)=>{
            let contentColor = config.colors.content;
            return contentColor.open + (0, _escapeHTML.default)(text) + contentColor.close;
        };
        exports.printText = printText;
        var printComment = (comment, config)=>{
            let commentColor = config.colors.comment;
            return `${commentColor.open}<!--${(0, _escapeHTML.default)(comment)}-->${commentColor.close}`;
        };
        exports.printComment = printComment;
        var printElement = (type, printedProps, printedChildren, config, indentation)=>{
            let tagColor = config.colors.tag;
            return `${tagColor.open}<${type}${printedProps && tagColor.close + printedProps + config.spacingOuter + indentation + tagColor.open}${printedChildren ? `>${tagColor.close}${printedChildren}${config.spacingOuter}${indentation}${tagColor.open}</${type}` : `${printedProps && !config.min ? "" : " "}/`}>${tagColor.close}`;
        };
        exports.printElement = printElement;
        var printElementAsLeaf = (type, config)=>{
            let tagColor = config.colors.tag;
            return `${tagColor.open}<${type}${tagColor.close} \u2026${tagColor.open} />${tagColor.close}`;
        };
        exports.printElementAsLeaf = printElementAsLeaf;
    }
}), require_DOMElement = __commonJS({
    "../../node_modules/pretty-format/build/plugins/DOMElement.js" (exports) {
        Object.defineProperty(exports, "__esModule", {
            value: !0
        }), exports.test = exports.serialize = exports.default = void 0;
        var _markup = require_markup(), ELEMENT_NODE = 1, TEXT_NODE = 3, COMMENT_NODE = 8, FRAGMENT_NODE = 11, ELEMENT_REGEXP = /^((HTML|SVG)\w*)?Element$/, testHasAttribute = (val)=>{
            try {
                return typeof val.hasAttribute == "function" && val.hasAttribute("is");
            } catch  {
                return !1;
            }
        }, testNode = (val)=>{
            let constructorName = val.constructor.name, { nodeType, tagName } = val, isCustomElement = typeof tagName == "string" && tagName.includes("-") || testHasAttribute(val);
            return nodeType === ELEMENT_NODE && (ELEMENT_REGEXP.test(constructorName) || isCustomElement) || nodeType === TEXT_NODE && constructorName === "Text" || nodeType === COMMENT_NODE && constructorName === "Comment" || nodeType === FRAGMENT_NODE && constructorName === "DocumentFragment";
        }, test = (val)=>val?.constructor?.name && testNode(val);
        exports.test = test;
        function nodeIsText(node) {
            return node.nodeType === TEXT_NODE;
        }
        function nodeIsComment(node) {
            return node.nodeType === COMMENT_NODE;
        }
        function nodeIsFragment(node) {
            return node.nodeType === FRAGMENT_NODE;
        }
        var serialize = (node, config, indentation, depth, refs, printer)=>{
            if (nodeIsText(node)) return (0, _markup.printText)(node.data, config);
            if (nodeIsComment(node)) return (0, _markup.printComment)(node.data, config);
            let type = nodeIsFragment(node) ? "DocumentFragment" : node.tagName.toLowerCase();
            return ++depth > config.maxDepth ? (0, _markup.printElementAsLeaf)(type, config) : (0, _markup.printElement)(type, (0, _markup.printProps)(nodeIsFragment(node) ? [] : Array.from(node.attributes, (attr)=>attr.name).sort(), nodeIsFragment(node) ? {} : Array.from(node.attributes).reduce((props, attribute)=>(props[attribute.name] = attribute.value, props), {}), config, indentation + config.indent, depth, refs, printer), (0, _markup.printChildren)(Array.prototype.slice.call(node.childNodes || node.children), config, indentation + config.indent, depth, refs, printer), config, indentation);
        };
        exports.serialize = serialize;
        var plugin = {
            serialize,
            test
        }, _default = plugin;
        exports.default = _default;
    }
}), require_Immutable = __commonJS({
    "../../node_modules/pretty-format/build/plugins/Immutable.js" (exports) {
        Object.defineProperty(exports, "__esModule", {
            value: !0
        }), exports.test = exports.serialize = exports.default = void 0;
        var _collections = require_collections(), IS_ITERABLE_SENTINEL = "@@__IMMUTABLE_ITERABLE__@@", IS_LIST_SENTINEL = "@@__IMMUTABLE_LIST__@@", IS_KEYED_SENTINEL = "@@__IMMUTABLE_KEYED__@@", IS_MAP_SENTINEL = "@@__IMMUTABLE_MAP__@@", IS_ORDERED_SENTINEL = "@@__IMMUTABLE_ORDERED__@@", IS_RECORD_SENTINEL = "@@__IMMUTABLE_RECORD__@@", IS_SEQ_SENTINEL = "@@__IMMUTABLE_SEQ__@@", IS_SET_SENTINEL = "@@__IMMUTABLE_SET__@@", IS_STACK_SENTINEL = "@@__IMMUTABLE_STACK__@@", getImmutableName = (name)=>`Immutable.${name}`, printAsLeaf = (name)=>`[${name}]`, SPACE = " ", LAZY = "\u2026", printImmutableEntries = (val, config, indentation, depth, refs, printer, type)=>++depth > config.maxDepth ? printAsLeaf(getImmutableName(type)) : `${getImmutableName(type) + SPACE}{${(0, _collections.printIteratorEntries)(val.entries(), config, indentation, depth, refs, printer)}}`;
        function getRecordEntries(val) {
            let i = 0;
            return {
                next () {
                    if (i < val._keys.length) {
                        let key = val._keys[i++];
                        return {
                            done: !1,
                            value: [
                                key,
                                val.get(key)
                            ]
                        };
                    }
                    return {
                        done: !0,
                        value: void 0
                    };
                }
            };
        }
        var printImmutableRecord = (val, config, indentation, depth, refs, printer)=>{
            let name = getImmutableName(val._name || "Record");
            return ++depth > config.maxDepth ? printAsLeaf(name) : `${name + SPACE}{${(0, _collections.printIteratorEntries)(getRecordEntries(val), config, indentation, depth, refs, printer)}}`;
        }, printImmutableSeq = (val, config, indentation, depth, refs, printer)=>{
            let name = getImmutableName("Seq");
            return ++depth > config.maxDepth ? printAsLeaf(name) : val[IS_KEYED_SENTINEL] ? `${name + SPACE}{${val._iter || val._object ? (0, _collections.printIteratorEntries)(val.entries(), config, indentation, depth, refs, printer) : LAZY}}` : `${name + SPACE}[${val._iter || val._array || val._collection || val._iterable ? (0, _collections.printIteratorValues)(val.values(), config, indentation, depth, refs, printer) : LAZY}]`;
        }, printImmutableValues = (val, config, indentation, depth, refs, printer, type)=>++depth > config.maxDepth ? printAsLeaf(getImmutableName(type)) : `${getImmutableName(type) + SPACE}[${(0, _collections.printIteratorValues)(val.values(), config, indentation, depth, refs, printer)}]`, serialize = (val, config, indentation, depth, refs, printer)=>val[IS_MAP_SENTINEL] ? printImmutableEntries(val, config, indentation, depth, refs, printer, val[IS_ORDERED_SENTINEL] ? "OrderedMap" : "Map") : val[IS_LIST_SENTINEL] ? printImmutableValues(val, config, indentation, depth, refs, printer, "List") : val[IS_SET_SENTINEL] ? printImmutableValues(val, config, indentation, depth, refs, printer, val[IS_ORDERED_SENTINEL] ? "OrderedSet" : "Set") : val[IS_STACK_SENTINEL] ? printImmutableValues(val, config, indentation, depth, refs, printer, "Stack") : val[IS_SEQ_SENTINEL] ? printImmutableSeq(val, config, indentation, depth, refs, printer) : printImmutableRecord(val, config, indentation, depth, refs, printer);
        exports.serialize = serialize;
        var test = (val)=>val && (val[IS_ITERABLE_SENTINEL] === !0 || val[IS_RECORD_SENTINEL] === !0);
        exports.test = test;
        var plugin = {
            serialize,
            test
        }, _default = plugin;
        exports.default = _default;
    }
}), require_react_is_development = __commonJS({
    "../../node_modules/pretty-format/node_modules/react-is/cjs/react-is.development.js" (exports) {
        (function() {
            var REACT_ELEMENT_TYPE = Symbol.for("react.element"), REACT_PORTAL_TYPE = Symbol.for("react.portal"), REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), REACT_PROFILER_TYPE = Symbol.for("react.profiler"), REACT_PROVIDER_TYPE = Symbol.for("react.provider"), REACT_CONTEXT_TYPE = Symbol.for("react.context"), REACT_SERVER_CONTEXT_TYPE = Symbol.for("react.server_context"), REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list"), REACT_MEMO_TYPE = Symbol.for("react.memo"), REACT_LAZY_TYPE = Symbol.for("react.lazy"), REACT_OFFSCREEN_TYPE = Symbol.for("react.offscreen"), enableScopeAPI = !1, enableCacheElement = !1, enableTransitionTracing = !1, enableLegacyHidden = !1, enableDebugTracing = !1, REACT_MODULE_REFERENCE;
            REACT_MODULE_REFERENCE = Symbol.for("react.module.reference");
            function isValidElementType(type) {
                return !!(typeof type == "string" || typeof type == "function" || type === REACT_FRAGMENT_TYPE || type === REACT_PROFILER_TYPE || enableDebugTracing || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || enableLegacyHidden || type === REACT_OFFSCREEN_TYPE || enableScopeAPI || enableCacheElement || enableTransitionTracing || typeof type == "object" && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_MODULE_REFERENCE || type.getModuleId !== void 0));
            }
            function typeOf(object) {
                if (typeof object == "object" && object !== null) {
                    var $$typeof = object.$$typeof;
                    switch($$typeof){
                        case REACT_ELEMENT_TYPE:
                            var type = object.type;
                            switch(type){
                                case REACT_FRAGMENT_TYPE:
                                case REACT_PROFILER_TYPE:
                                case REACT_STRICT_MODE_TYPE:
                                case REACT_SUSPENSE_TYPE:
                                case REACT_SUSPENSE_LIST_TYPE:
                                    return type;
                                default:
                                    var $$typeofType = type && type.$$typeof;
                                    switch($$typeofType){
                                        case REACT_SERVER_CONTEXT_TYPE:
                                        case REACT_CONTEXT_TYPE:
                                        case REACT_FORWARD_REF_TYPE:
                                        case REACT_LAZY_TYPE:
                                        case REACT_MEMO_TYPE:
                                        case REACT_PROVIDER_TYPE:
                                            return $$typeofType;
                                        default:
                                            return $$typeof;
                                    }
                            }
                        case REACT_PORTAL_TYPE:
                            return $$typeof;
                    }
                }
            }
            var ContextConsumer = REACT_CONTEXT_TYPE, ContextProvider = REACT_PROVIDER_TYPE, Element2 = REACT_ELEMENT_TYPE, ForwardRef = REACT_FORWARD_REF_TYPE, Fragment = REACT_FRAGMENT_TYPE, Lazy = REACT_LAZY_TYPE, Memo = REACT_MEMO_TYPE, Portal = REACT_PORTAL_TYPE, Profiler = REACT_PROFILER_TYPE, StrictMode = REACT_STRICT_MODE_TYPE, Suspense = REACT_SUSPENSE_TYPE, SuspenseList = REACT_SUSPENSE_LIST_TYPE, hasWarnedAboutDeprecatedIsAsyncMode = !1, hasWarnedAboutDeprecatedIsConcurrentMode = !1;
            function isAsyncMode(object) {
                return hasWarnedAboutDeprecatedIsAsyncMode || (hasWarnedAboutDeprecatedIsAsyncMode = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 18+.")), !1;
            }
            function isConcurrentMode(object) {
                return hasWarnedAboutDeprecatedIsConcurrentMode || (hasWarnedAboutDeprecatedIsConcurrentMode = !0, console.warn("The ReactIs.isConcurrentMode() alias has been deprecated, and will be removed in React 18+.")), !1;
            }
            function isContextConsumer(object) {
                return typeOf(object) === REACT_CONTEXT_TYPE;
            }
            function isContextProvider(object) {
                return typeOf(object) === REACT_PROVIDER_TYPE;
            }
            function isElement(object) {
                return typeof object == "object" && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
            }
            function isForwardRef(object) {
                return typeOf(object) === REACT_FORWARD_REF_TYPE;
            }
            function isFragment(object) {
                return typeOf(object) === REACT_FRAGMENT_TYPE;
            }
            function isLazy(object) {
                return typeOf(object) === REACT_LAZY_TYPE;
            }
            function isMemo(object) {
                return typeOf(object) === REACT_MEMO_TYPE;
            }
            function isPortal(object) {
                return typeOf(object) === REACT_PORTAL_TYPE;
            }
            function isProfiler(object) {
                return typeOf(object) === REACT_PROFILER_TYPE;
            }
            function isStrictMode(object) {
                return typeOf(object) === REACT_STRICT_MODE_TYPE;
            }
            function isSuspense(object) {
                return typeOf(object) === REACT_SUSPENSE_TYPE;
            }
            function isSuspenseList(object) {
                return typeOf(object) === REACT_SUSPENSE_LIST_TYPE;
            }
            exports.ContextConsumer = ContextConsumer, exports.ContextProvider = ContextProvider, exports.Element = Element2, exports.ForwardRef = ForwardRef, exports.Fragment = Fragment, exports.Lazy = Lazy, exports.Memo = Memo, exports.Portal = Portal, exports.Profiler = Profiler, exports.StrictMode = StrictMode, exports.Suspense = Suspense, exports.SuspenseList = SuspenseList, exports.isAsyncMode = isAsyncMode, exports.isConcurrentMode = isConcurrentMode, exports.isContextConsumer = isContextConsumer, exports.isContextProvider = isContextProvider, exports.isElement = isElement, exports.isForwardRef = isForwardRef, exports.isFragment = isFragment, exports.isLazy = isLazy, exports.isMemo = isMemo, exports.isPortal = isPortal, exports.isProfiler = isProfiler, exports.isStrictMode = isStrictMode, exports.isSuspense = isSuspense, exports.isSuspenseList = isSuspenseList, exports.isValidElementType = isValidElementType, exports.typeOf = typeOf;
        })();
    }
}), require_react_is = __commonJS({
    "../../node_modules/pretty-format/node_modules/react-is/index.js" (exports, module) {
        module.exports = require_react_is_development();
    }
}), require_ReactElement = __commonJS({
    "../../node_modules/pretty-format/build/plugins/ReactElement.js" (exports) {
        Object.defineProperty(exports, "__esModule", {
            value: !0
        }), exports.test = exports.serialize = exports.default = void 0;
        var ReactIs = _interopRequireWildcard(require_react_is()), _markup = require_markup();
        function _getRequireWildcardCache(nodeInterop) {
            if (typeof WeakMap != "function") return null;
            var cacheBabelInterop = new WeakMap, cacheNodeInterop = new WeakMap;
            return (_getRequireWildcardCache = function(nodeInterop2) {
                return nodeInterop2 ? cacheNodeInterop : cacheBabelInterop;
            })(nodeInterop);
        }
        function _interopRequireWildcard(obj, nodeInterop) {
            if (!nodeInterop && obj && obj.__esModule) return obj;
            if (obj === null || typeof obj != "object" && typeof obj != "function") return {
                default: obj
            };
            var cache = _getRequireWildcardCache(nodeInterop);
            if (cache && cache.has(obj)) return cache.get(obj);
            var newObj = {}, hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
            for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
                var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
                desc && (desc.get || desc.set) ? Object.defineProperty(newObj, key, desc) : newObj[key] = obj[key];
            }
            return newObj.default = obj, cache && cache.set(obj, newObj), newObj;
        }
        var getChildren = (arg, children = [])=>(Array.isArray(arg) ? arg.forEach((item)=>{
                getChildren(item, children);
            }) : arg != null && arg !== !1 && children.push(arg), children), getType3 = (element)=>{
            let type = element.type;
            if (typeof type == "string") return type;
            if (typeof type == "function") return type.displayName || type.name || "Unknown";
            if (ReactIs.isFragment(element)) return "React.Fragment";
            if (ReactIs.isSuspense(element)) return "React.Suspense";
            if (typeof type == "object" && type !== null) {
                if (ReactIs.isContextProvider(element)) return "Context.Provider";
                if (ReactIs.isContextConsumer(element)) return "Context.Consumer";
                if (ReactIs.isForwardRef(element)) {
                    if (type.displayName) return type.displayName;
                    let functionName = type.render.displayName || type.render.name || "";
                    return functionName !== "" ? `ForwardRef(${functionName})` : "ForwardRef";
                }
                if (ReactIs.isMemo(element)) {
                    let functionName = type.displayName || type.type.displayName || type.type.name || "";
                    return functionName !== "" ? `Memo(${functionName})` : "Memo";
                }
            }
            return "UNDEFINED";
        }, getPropKeys = (element)=>{
            let { props } = element;
            return Object.keys(props).filter((key)=>key !== "children" && props[key] !== void 0).sort();
        }, serialize = (element, config, indentation, depth, refs, printer)=>++depth > config.maxDepth ? (0, _markup.printElementAsLeaf)(getType3(element), config) : (0, _markup.printElement)(getType3(element), (0, _markup.printProps)(getPropKeys(element), element.props, config, indentation + config.indent, depth, refs, printer), (0, _markup.printChildren)(getChildren(element.props.children), config, indentation + config.indent, depth, refs, printer), config, indentation);
        exports.serialize = serialize;
        var test = (val)=>val != null && ReactIs.isElement(val);
        exports.test = test;
        var plugin = {
            serialize,
            test
        }, _default = plugin;
        exports.default = _default;
    }
}), require_ReactTestComponent = __commonJS({
    "../../node_modules/pretty-format/build/plugins/ReactTestComponent.js" (exports) {
        Object.defineProperty(exports, "__esModule", {
            value: !0
        }), exports.test = exports.serialize = exports.default = void 0;
        var _markup = require_markup(), Symbol2 = globalThis["jest-symbol-do-not-touch"] || globalThis.Symbol, testSymbol = typeof Symbol2 == "function" && Symbol2.for ? Symbol2.for("react.test.json") : 245830487, getPropKeys = (object)=>{
            let { props } = object;
            return props ? Object.keys(props).filter((key)=>props[key] !== void 0).sort() : [];
        }, serialize = (object, config, indentation, depth, refs, printer)=>++depth > config.maxDepth ? (0, _markup.printElementAsLeaf)(object.type, config) : (0, _markup.printElement)(object.type, object.props ? (0, _markup.printProps)(getPropKeys(object), object.props, config, indentation + config.indent, depth, refs, printer) : "", object.children ? (0, _markup.printChildren)(object.children, config, indentation + config.indent, depth, refs, printer) : "", config, indentation);
        exports.serialize = serialize;
        var test = (val)=>val && val.$$typeof === testSymbol;
        exports.test = test;
        var plugin = {
            serialize,
            test
        }, _default = plugin;
        exports.default = _default;
    }
}), require_build = __commonJS({
    "../../node_modules/pretty-format/build/index.js" (exports) {
        Object.defineProperty(exports, "__esModule", {
            value: !0
        }), exports.default = exports.DEFAULT_OPTIONS = void 0, exports.format = format3, exports.plugins = void 0;
        var _ansiStyles = _interopRequireDefault(require_ansi_styles()), _collections = require_collections(), _AsymmetricMatcher = _interopRequireDefault(require_AsymmetricMatcher()), _DOMCollection = _interopRequireDefault(require_DOMCollection()), _DOMElement = _interopRequireDefault(require_DOMElement()), _Immutable = _interopRequireDefault(require_Immutable()), _ReactElement = _interopRequireDefault(require_ReactElement()), _ReactTestComponent = _interopRequireDefault(require_ReactTestComponent());
        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                default: obj
            };
        }
        var toString = Object.prototype.toString, toISOString = Date.prototype.toISOString, errorToString = Error.prototype.toString, regExpToString = RegExp.prototype.toString, getConstructorName = (val)=>typeof val.constructor == "function" && val.constructor.name || "Object", isWindow = (val)=>typeof window < "u" && val === window, SYMBOL_REGEXP = /^Symbol\((.*)\)(.*)$/, NEWLINE_REGEXP = /\n/gi, PrettyFormatPluginError = class extends Error {
            constructor(message, stack){
                super(message), this.stack = stack, this.name = this.constructor.name;
            }
        };
        function isToStringedArrayType(toStringed) {
            return toStringed === "[object Array]" || toStringed === "[object ArrayBuffer]" || toStringed === "[object DataView]" || toStringed === "[object Float32Array]" || toStringed === "[object Float64Array]" || toStringed === "[object Int8Array]" || toStringed === "[object Int16Array]" || toStringed === "[object Int32Array]" || toStringed === "[object Uint8Array]" || toStringed === "[object Uint8ClampedArray]" || toStringed === "[object Uint16Array]" || toStringed === "[object Uint32Array]";
        }
        function printNumber(val) {
            return Object.is(val, -0) ? "-0" : String(val);
        }
        function printBigInt(val) {
            return `${val}n`;
        }
        function printFunction(val, printFunctionName) {
            return printFunctionName ? `[Function ${val.name || "anonymous"}]` : "[Function]";
        }
        function printSymbol(val) {
            return String(val).replace(SYMBOL_REGEXP, "Symbol($1)");
        }
        function printError(val) {
            return `[${errorToString.call(val)}]`;
        }
        function printBasicValue(val, printFunctionName, escapeRegex, escapeString) {
            if (val === !0 || val === !1) return `${val}`;
            if (val === void 0) return "undefined";
            if (val === null) return "null";
            let typeOf = typeof val;
            if (typeOf === "number") return printNumber(val);
            if (typeOf === "bigint") return printBigInt(val);
            if (typeOf === "string") return escapeString ? `"${val.replace(/"|\\/g, "\\$&")}"` : `"${val}"`;
            if (typeOf === "function") return printFunction(val, printFunctionName);
            if (typeOf === "symbol") return printSymbol(val);
            let toStringed = toString.call(val);
            return toStringed === "[object WeakMap]" ? "WeakMap {}" : toStringed === "[object WeakSet]" ? "WeakSet {}" : toStringed === "[object Function]" || toStringed === "[object GeneratorFunction]" ? printFunction(val, printFunctionName) : toStringed === "[object Symbol]" ? printSymbol(val) : toStringed === "[object Date]" ? isNaN(+val) ? "Date { NaN }" : toISOString.call(val) : toStringed === "[object Error]" ? printError(val) : toStringed === "[object RegExp]" ? escapeRegex ? regExpToString.call(val).replace(/[\\^$*+?.()|[\]{}]/g, "\\$&") : regExpToString.call(val) : val instanceof Error ? printError(val) : null;
        }
        function printComplexValue(val, config, indentation, depth, refs, hasCalledToJSON) {
            if (refs.indexOf(val) !== -1) return "[Circular]";
            refs = refs.slice(), refs.push(val);
            let hitMaxDepth = ++depth > config.maxDepth, min = config.min;
            if (config.callToJSON && !hitMaxDepth && val.toJSON && typeof val.toJSON == "function" && !hasCalledToJSON) return printer(val.toJSON(), config, indentation, depth, refs, !0);
            let toStringed = toString.call(val);
            return toStringed === "[object Arguments]" ? hitMaxDepth ? "[Arguments]" : `${min ? "" : "Arguments "}[${(0, _collections.printListItems)(val, config, indentation, depth, refs, printer)}]` : isToStringedArrayType(toStringed) ? hitMaxDepth ? `[${val.constructor.name}]` : `${min || !config.printBasicPrototype && val.constructor.name === "Array" ? "" : `${val.constructor.name} `}[${(0, _collections.printListItems)(val, config, indentation, depth, refs, printer)}]` : toStringed === "[object Map]" ? hitMaxDepth ? "[Map]" : `Map {${(0, _collections.printIteratorEntries)(val.entries(), config, indentation, depth, refs, printer, " => ")}}` : toStringed === "[object Set]" ? hitMaxDepth ? "[Set]" : `Set {${(0, _collections.printIteratorValues)(val.values(), config, indentation, depth, refs, printer)}}` : hitMaxDepth || isWindow(val) ? `[${getConstructorName(val)}]` : `${min || !config.printBasicPrototype && getConstructorName(val) === "Object" ? "" : `${getConstructorName(val)} `}{${(0, _collections.printObjectProperties)(val, config, indentation, depth, refs, printer)}}`;
        }
        function isNewPlugin(plugin) {
            return plugin.serialize != null;
        }
        function printPlugin(plugin, val, config, indentation, depth, refs) {
            let printed;
            try {
                printed = isNewPlugin(plugin) ? plugin.serialize(val, config, indentation, depth, refs, printer) : plugin.print(val, (valChild)=>printer(valChild, config, indentation, depth, refs), (str)=>{
                    let indentationNext = indentation + config.indent;
                    return indentationNext + str.replace(NEWLINE_REGEXP, `
${indentationNext}`);
                }, {
                    edgeSpacing: config.spacingOuter,
                    min: config.min,
                    spacing: config.spacingInner
                }, config.colors);
            } catch (error) {
                throw new PrettyFormatPluginError(error.message, error.stack);
            }
            if (typeof printed != "string") throw new Error(`pretty-format: Plugin must return type "string" but instead returned "${typeof printed}".`);
            return printed;
        }
        function findPlugin(plugins4, val) {
            for(let p = 0; p < plugins4.length; p++)try {
                if (plugins4[p].test(val)) return plugins4[p];
            } catch (error) {
                throw new PrettyFormatPluginError(error.message, error.stack);
            }
            return null;
        }
        function printer(val, config, indentation, depth, refs, hasCalledToJSON) {
            let plugin = findPlugin(config.plugins, val);
            if (plugin !== null) return printPlugin(plugin, val, config, indentation, depth, refs);
            let basicResult = printBasicValue(val, config.printFunctionName, config.escapeRegex, config.escapeString);
            return basicResult !== null ? basicResult : printComplexValue(val, config, indentation, depth, refs, hasCalledToJSON);
        }
        var DEFAULT_THEME = {
            comment: "gray",
            content: "reset",
            prop: "yellow",
            tag: "cyan",
            value: "green"
        }, DEFAULT_THEME_KEYS = Object.keys(DEFAULT_THEME), toOptionsSubtype = (options)=>options, DEFAULT_OPTIONS = toOptionsSubtype({
            callToJSON: !0,
            compareKeys: void 0,
            escapeRegex: !1,
            escapeString: !0,
            highlight: !1,
            indent: 2,
            maxDepth: 1 / 0,
            maxWidth: 1 / 0,
            min: !1,
            plugins: [],
            printBasicPrototype: !0,
            printFunctionName: !0,
            theme: DEFAULT_THEME
        });
        exports.DEFAULT_OPTIONS = DEFAULT_OPTIONS;
        function validateOptions(options) {
            if (Object.keys(options).forEach((key)=>{
                if (!Object.prototype.hasOwnProperty.call(DEFAULT_OPTIONS, key)) throw new Error(`pretty-format: Unknown option "${key}".`);
            }), options.min && options.indent !== void 0 && options.indent !== 0) throw new Error('pretty-format: Options "min" and "indent" cannot be used together.');
            if (options.theme !== void 0) {
                if (options.theme === null) throw new Error('pretty-format: Option "theme" must not be null.');
                if (typeof options.theme != "object") throw new Error(`pretty-format: Option "theme" must be of type "object" but instead received "${typeof options.theme}".`);
            }
        }
        var getColorsHighlight = (options)=>DEFAULT_THEME_KEYS.reduce((colors, key)=>{
                let value = options.theme && options.theme[key] !== void 0 ? options.theme[key] : DEFAULT_THEME[key], color = value && _ansiStyles.default[value];
                if (color && typeof color.close == "string" && typeof color.open == "string") colors[key] = color;
                else throw new Error(`pretty-format: Option "theme" has a key "${key}" whose value "${value}" is undefined in ansi-styles.`);
                return colors;
            }, Object.create(null)), getColorsEmpty = ()=>DEFAULT_THEME_KEYS.reduce((colors, key)=>(colors[key] = {
                    close: "",
                    open: ""
                }, colors), Object.create(null)), getPrintFunctionName = (options)=>options?.printFunctionName ?? DEFAULT_OPTIONS.printFunctionName, getEscapeRegex = (options)=>options?.escapeRegex ?? DEFAULT_OPTIONS.escapeRegex, getEscapeString = (options)=>options?.escapeString ?? DEFAULT_OPTIONS.escapeString, getConfig = (options)=>({
                callToJSON: options?.callToJSON ?? DEFAULT_OPTIONS.callToJSON,
                colors: options?.highlight ? getColorsHighlight(options) : getColorsEmpty(),
                compareKeys: typeof options?.compareKeys == "function" || options?.compareKeys === null ? options.compareKeys : DEFAULT_OPTIONS.compareKeys,
                escapeRegex: getEscapeRegex(options),
                escapeString: getEscapeString(options),
                indent: options?.min ? "" : createIndent(options?.indent ?? DEFAULT_OPTIONS.indent),
                maxDepth: options?.maxDepth ?? DEFAULT_OPTIONS.maxDepth,
                maxWidth: options?.maxWidth ?? DEFAULT_OPTIONS.maxWidth,
                min: options?.min ?? DEFAULT_OPTIONS.min,
                plugins: options?.plugins ?? DEFAULT_OPTIONS.plugins,
                printBasicPrototype: options?.printBasicPrototype ?? !0,
                printFunctionName: getPrintFunctionName(options),
                spacingInner: options?.min ? " " : `
`,
                spacingOuter: options?.min ? "" : `
`
            });
        function createIndent(indent) {
            return new Array(indent + 1).join(" ");
        }
        function format3(val, options) {
            if (options && (validateOptions(options), options.plugins)) {
                let plugin = findPlugin(options.plugins, val);
                if (plugin !== null) return printPlugin(plugin, val, getConfig(options), "", 0, []);
            }
            let basicResult = printBasicValue(val, getPrintFunctionName(options), getEscapeRegex(options), getEscapeString(options));
            return basicResult !== null ? basicResult : printComplexValue(val, getConfig(options), "", 0, []);
        }
        var plugins3 = {
            AsymmetricMatcher: _AsymmetricMatcher.default,
            DOMCollection: _DOMCollection.default,
            DOMElement: _DOMElement.default,
            Immutable: _Immutable.default,
            ReactElement: _ReactElement.default,
            ReactTestComponent: _ReactTestComponent.default
        };
        exports.plugins = plugins3;
        var _default = format3;
        exports.default = _default;
    }
}), require_build2 = __commonJS({
    "../../node_modules/diff-sequences/build/index.js" (exports) {
        Object.defineProperty(exports, "__esModule", {
            value: !0
        }), exports.default = diffSequence;
        var pkg = "diff-sequences", NOT_YET_SET = 0, countCommonItemsF = (aIndex, aEnd, bIndex, bEnd, isCommon)=>{
            let nCommon = 0;
            for(; aIndex < aEnd && bIndex < bEnd && isCommon(aIndex, bIndex);)aIndex += 1, bIndex += 1, nCommon += 1;
            return nCommon;
        }, countCommonItemsR = (aStart, aIndex, bStart, bIndex, isCommon)=>{
            let nCommon = 0;
            for(; aStart <= aIndex && bStart <= bIndex && isCommon(aIndex, bIndex);)aIndex -= 1, bIndex -= 1, nCommon += 1;
            return nCommon;
        }, extendPathsF = (d, aEnd, bEnd, bF, isCommon, aIndexesF, iMaxF)=>{
            let iF = 0, kF = -d, aFirst = aIndexesF[iF], aIndexPrev1 = aFirst;
            aIndexesF[iF] += countCommonItemsF(aFirst + 1, aEnd, bF + aFirst - kF + 1, bEnd, isCommon);
            let nF = d < iMaxF ? d : iMaxF;
            for(iF += 1, kF += 2; iF <= nF; iF += 1, kF += 2){
                if (iF !== d && aIndexPrev1 < aIndexesF[iF]) aFirst = aIndexesF[iF];
                else if (aFirst = aIndexPrev1 + 1, aEnd <= aFirst) return iF - 1;
                aIndexPrev1 = aIndexesF[iF], aIndexesF[iF] = aFirst + countCommonItemsF(aFirst + 1, aEnd, bF + aFirst - kF + 1, bEnd, isCommon);
            }
            return iMaxF;
        }, extendPathsR = (d, aStart, bStart, bR, isCommon, aIndexesR, iMaxR)=>{
            let iR = 0, kR = d, aFirst = aIndexesR[iR], aIndexPrev1 = aFirst;
            aIndexesR[iR] -= countCommonItemsR(aStart, aFirst - 1, bStart, bR + aFirst - kR - 1, isCommon);
            let nR = d < iMaxR ? d : iMaxR;
            for(iR += 1, kR -= 2; iR <= nR; iR += 1, kR -= 2){
                if (iR !== d && aIndexesR[iR] < aIndexPrev1) aFirst = aIndexesR[iR];
                else if (aFirst = aIndexPrev1 - 1, aFirst < aStart) return iR - 1;
                aIndexPrev1 = aIndexesR[iR], aIndexesR[iR] = aFirst - countCommonItemsR(aStart, aFirst - 1, bStart, bR + aFirst - kR - 1, isCommon);
            }
            return iMaxR;
        }, extendOverlappablePathsF = (d, aStart, aEnd, bStart, bEnd, isCommon, aIndexesF, iMaxF, aIndexesR, iMaxR, division)=>{
            let bF = bStart - aStart, aLength = aEnd - aStart, baDeltaLength = bEnd - bStart - aLength, kMinOverlapF = -baDeltaLength - (d - 1), kMaxOverlapF = -baDeltaLength + (d - 1), aIndexPrev1 = NOT_YET_SET, nF = d < iMaxF ? d : iMaxF;
            for(let iF = 0, kF = -d; iF <= nF; iF += 1, kF += 2){
                let insert = iF === 0 || iF !== d && aIndexPrev1 < aIndexesF[iF], aLastPrev = insert ? aIndexesF[iF] : aIndexPrev1, aFirst = insert ? aLastPrev : aLastPrev + 1, bFirst = bF + aFirst - kF, nCommonF = countCommonItemsF(aFirst + 1, aEnd, bFirst + 1, bEnd, isCommon), aLast = aFirst + nCommonF;
                if (aIndexPrev1 = aIndexesF[iF], aIndexesF[iF] = aLast, kMinOverlapF <= kF && kF <= kMaxOverlapF) {
                    let iR = (d - 1 - (kF + baDeltaLength)) / 2;
                    if (iR <= iMaxR && aIndexesR[iR] - 1 <= aLast) {
                        let bLastPrev = bF + aLastPrev - (insert ? kF + 1 : kF - 1), nCommonR = countCommonItemsR(aStart, aLastPrev, bStart, bLastPrev, isCommon), aIndexPrevFirst = aLastPrev - nCommonR, bIndexPrevFirst = bLastPrev - nCommonR, aEndPreceding = aIndexPrevFirst + 1, bEndPreceding = bIndexPrevFirst + 1;
                        division.nChangePreceding = d - 1, d - 1 === aEndPreceding + bEndPreceding - aStart - bStart ? (division.aEndPreceding = aStart, division.bEndPreceding = bStart) : (division.aEndPreceding = aEndPreceding, division.bEndPreceding = bEndPreceding), division.nCommonPreceding = nCommonR, nCommonR !== 0 && (division.aCommonPreceding = aEndPreceding, division.bCommonPreceding = bEndPreceding), division.nCommonFollowing = nCommonF, nCommonF !== 0 && (division.aCommonFollowing = aFirst + 1, division.bCommonFollowing = bFirst + 1);
                        let aStartFollowing = aLast + 1, bStartFollowing = bFirst + nCommonF + 1;
                        return division.nChangeFollowing = d - 1, d - 1 === aEnd + bEnd - aStartFollowing - bStartFollowing ? (division.aStartFollowing = aEnd, division.bStartFollowing = bEnd) : (division.aStartFollowing = aStartFollowing, division.bStartFollowing = bStartFollowing), !0;
                    }
                }
            }
            return !1;
        }, extendOverlappablePathsR = (d, aStart, aEnd, bStart, bEnd, isCommon, aIndexesF, iMaxF, aIndexesR, iMaxR, division)=>{
            let bR = bEnd - aEnd, aLength = aEnd - aStart, baDeltaLength = bEnd - bStart - aLength, kMinOverlapR = baDeltaLength - d, kMaxOverlapR = baDeltaLength + d, aIndexPrev1 = NOT_YET_SET, nR = d < iMaxR ? d : iMaxR;
            for(let iR = 0, kR = d; iR <= nR; iR += 1, kR -= 2){
                let insert = iR === 0 || iR !== d && aIndexesR[iR] < aIndexPrev1, aLastPrev = insert ? aIndexesR[iR] : aIndexPrev1, aFirst = insert ? aLastPrev : aLastPrev - 1, bFirst = bR + aFirst - kR, nCommonR = countCommonItemsR(aStart, aFirst - 1, bStart, bFirst - 1, isCommon), aLast = aFirst - nCommonR;
                if (aIndexPrev1 = aIndexesR[iR], aIndexesR[iR] = aLast, kMinOverlapR <= kR && kR <= kMaxOverlapR) {
                    let iF = (d + (kR - baDeltaLength)) / 2;
                    if (iF <= iMaxF && aLast - 1 <= aIndexesF[iF]) {
                        let bLast = bFirst - nCommonR;
                        if (division.nChangePreceding = d, d === aLast + bLast - aStart - bStart ? (division.aEndPreceding = aStart, division.bEndPreceding = bStart) : (division.aEndPreceding = aLast, division.bEndPreceding = bLast), division.nCommonPreceding = nCommonR, nCommonR !== 0 && (division.aCommonPreceding = aLast, division.bCommonPreceding = bLast), division.nChangeFollowing = d - 1, d === 1) division.nCommonFollowing = 0, division.aStartFollowing = aEnd, division.bStartFollowing = bEnd;
                        else {
                            let bLastPrev = bR + aLastPrev - (insert ? kR - 1 : kR + 1), nCommonF = countCommonItemsF(aLastPrev, aEnd, bLastPrev, bEnd, isCommon);
                            division.nCommonFollowing = nCommonF, nCommonF !== 0 && (division.aCommonFollowing = aLastPrev, division.bCommonFollowing = bLastPrev);
                            let aStartFollowing = aLastPrev + nCommonF, bStartFollowing = bLastPrev + nCommonF;
                            d - 1 === aEnd + bEnd - aStartFollowing - bStartFollowing ? (division.aStartFollowing = aEnd, division.bStartFollowing = bEnd) : (division.aStartFollowing = aStartFollowing, division.bStartFollowing = bStartFollowing);
                        }
                        return !0;
                    }
                }
            }
            return !1;
        }, divide = (nChange, aStart, aEnd, bStart, bEnd, isCommon, aIndexesF, aIndexesR, division)=>{
            let bF = bStart - aStart, bR = bEnd - aEnd, aLength = aEnd - aStart, bLength = bEnd - bStart, baDeltaLength = bLength - aLength, iMaxF = aLength, iMaxR = aLength;
            if (aIndexesF[0] = aStart - 1, aIndexesR[0] = aEnd, baDeltaLength % 2 === 0) {
                let dMin = (nChange || baDeltaLength) / 2, dMax = (aLength + bLength) / 2;
                for(let d = 1; d <= dMax; d += 1)if (iMaxF = extendPathsF(d, aEnd, bEnd, bF, isCommon, aIndexesF, iMaxF), d < dMin) iMaxR = extendPathsR(d, aStart, bStart, bR, isCommon, aIndexesR, iMaxR);
                else if (extendOverlappablePathsR(d, aStart, aEnd, bStart, bEnd, isCommon, aIndexesF, iMaxF, aIndexesR, iMaxR, division)) return;
            } else {
                let dMin = ((nChange || baDeltaLength) + 1) / 2, dMax = (aLength + bLength + 1) / 2, d = 1;
                for(iMaxF = extendPathsF(d, aEnd, bEnd, bF, isCommon, aIndexesF, iMaxF), d += 1; d <= dMax; d += 1)if (iMaxR = extendPathsR(d - 1, aStart, bStart, bR, isCommon, aIndexesR, iMaxR), d < dMin) iMaxF = extendPathsF(d, aEnd, bEnd, bF, isCommon, aIndexesF, iMaxF);
                else if (extendOverlappablePathsF(d, aStart, aEnd, bStart, bEnd, isCommon, aIndexesF, iMaxF, aIndexesR, iMaxR, division)) return;
            }
            throw new Error(`${pkg}: no overlap aStart=${aStart} aEnd=${aEnd} bStart=${bStart} bEnd=${bEnd}`);
        }, findSubsequences = (nChange, aStart, aEnd, bStart, bEnd, transposed, callbacks, aIndexesF, aIndexesR, division)=>{
            if (bEnd - bStart < aEnd - aStart) {
                if (transposed = !transposed, transposed && callbacks.length === 1) {
                    let { foundSubsequence: foundSubsequence2, isCommon: isCommon2 } = callbacks[0];
                    callbacks[1] = {
                        foundSubsequence: (nCommon, bCommon, aCommon)=>{
                            foundSubsequence2(nCommon, aCommon, bCommon);
                        },
                        isCommon: (bIndex, aIndex)=>isCommon2(aIndex, bIndex)
                    };
                }
                let tStart = aStart, tEnd = aEnd;
                aStart = bStart, aEnd = bEnd, bStart = tStart, bEnd = tEnd;
            }
            let { foundSubsequence, isCommon } = callbacks[transposed ? 1 : 0];
            divide(nChange, aStart, aEnd, bStart, bEnd, isCommon, aIndexesF, aIndexesR, division);
            let { nChangePreceding, aEndPreceding, bEndPreceding, nCommonPreceding, aCommonPreceding, bCommonPreceding, nCommonFollowing, aCommonFollowing, bCommonFollowing, nChangeFollowing, aStartFollowing, bStartFollowing } = division;
            aStart < aEndPreceding && bStart < bEndPreceding && findSubsequences(nChangePreceding, aStart, aEndPreceding, bStart, bEndPreceding, transposed, callbacks, aIndexesF, aIndexesR, division), nCommonPreceding !== 0 && foundSubsequence(nCommonPreceding, aCommonPreceding, bCommonPreceding), nCommonFollowing !== 0 && foundSubsequence(nCommonFollowing, aCommonFollowing, bCommonFollowing), aStartFollowing < aEnd && bStartFollowing < bEnd && findSubsequences(nChangeFollowing, aStartFollowing, aEnd, bStartFollowing, bEnd, transposed, callbacks, aIndexesF, aIndexesR, division);
        }, validateLength = (name, arg)=>{
            if (typeof arg != "number") throw new TypeError(`${pkg}: ${name} typeof ${typeof arg} is not a number`);
            if (!Number.isSafeInteger(arg)) throw new RangeError(`${pkg}: ${name} value ${arg} is not a safe integer`);
            if (arg < 0) throw new RangeError(`${pkg}: ${name} value ${arg} is a negative integer`);
        }, validateCallback = (name, arg)=>{
            let type = typeof arg;
            if (type !== "function") throw new TypeError(`${pkg}: ${name} typeof ${type} is not a function`);
        };
        function diffSequence(aLength, bLength, isCommon, foundSubsequence) {
            validateLength("aLength", aLength), validateLength("bLength", bLength), validateCallback("isCommon", isCommon), validateCallback("foundSubsequence", foundSubsequence);
            let nCommonF = countCommonItemsF(0, aLength, 0, bLength, isCommon);
            if (nCommonF !== 0 && foundSubsequence(nCommonF, 0, 0), aLength !== nCommonF || bLength !== nCommonF) {
                let aStart = nCommonF, bStart = nCommonF, nCommonR = countCommonItemsR(aStart, aLength - 1, bStart, bLength - 1, isCommon), aEnd = aLength - nCommonR, bEnd = bLength - nCommonR, nCommonFR = nCommonF + nCommonR;
                aLength !== nCommonFR && bLength !== nCommonFR && findSubsequences(0, aStart, aEnd, bStart, bEnd, !1, [
                    {
                        foundSubsequence,
                        isCommon
                    }
                ], [
                    NOT_YET_SET
                ], [
                    NOT_YET_SET
                ], {
                    aCommonFollowing: NOT_YET_SET,
                    aCommonPreceding: NOT_YET_SET,
                    aEndPreceding: NOT_YET_SET,
                    aStartFollowing: NOT_YET_SET,
                    bCommonFollowing: NOT_YET_SET,
                    bCommonPreceding: NOT_YET_SET,
                    bEndPreceding: NOT_YET_SET,
                    bStartFollowing: NOT_YET_SET,
                    nChangeFollowing: NOT_YET_SET,
                    nChangePreceding: NOT_YET_SET,
                    nCommonFollowing: NOT_YET_SET,
                    nCommonPreceding: NOT_YET_SET
                }), nCommonR !== 0 && foundSubsequence(nCommonR, aEnd, bEnd);
            }
        }
    }
}), require_loupe = __commonJS({
    "../../node_modules/loupe/loupe.js" (exports, module) {
        (function(global22, factory) {
            typeof exports == "object" && typeof module < "u" ? factory(exports) : typeof define == "function" && define.amd ? define([
                "exports"
            ], factory) : (global22 = typeof globalThis < "u" ? globalThis : global22 || self, factory(global22.loupe = {}));
        })(exports, function(exports2) {
            function _typeof(obj) {
                "@babel/helpers - typeof";
                return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? _typeof = function(obj2) {
                    return typeof obj2;
                } : _typeof = function(obj2) {
                    return obj2 && typeof Symbol == "function" && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
                }, _typeof(obj);
            }
            function _slicedToArray(arr, i) {
                return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
            }
            function _arrayWithHoles(arr) {
                if (Array.isArray(arr)) return arr;
            }
            function _iterableToArrayLimit(arr, i) {
                if (!(typeof Symbol > "u" || !(Symbol.iterator in Object(arr)))) {
                    var _arr = [], _n = !0, _d = !1, _e = void 0;
                    try {
                        for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done) && (_arr.push(_s.value), !(i && _arr.length === i)); _n = !0);
                    } catch (err) {
                        _d = !0, _e = err;
                    } finally{
                        try {
                            !_n && _i.return != null && _i.return();
                        } finally{
                            if (_d) throw _e;
                        }
                    }
                    return _arr;
                }
            }
            function _unsupportedIterableToArray(o, minLen) {
                if (o) {
                    if (typeof o == "string") return _arrayLikeToArray(o, minLen);
                    var n = Object.prototype.toString.call(o).slice(8, -1);
                    if (n === "Object" && o.constructor && (n = o.constructor.name), n === "Map" || n === "Set") return Array.from(o);
                    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
                }
            }
            function _arrayLikeToArray(arr, len) {
                (len == null || len > arr.length) && (len = arr.length);
                for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
                return arr2;
            }
            function _nonIterableRest() {
                throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
            }
            var ansiColors = {
                bold: [
                    "1",
                    "22"
                ],
                dim: [
                    "2",
                    "22"
                ],
                italic: [
                    "3",
                    "23"
                ],
                underline: [
                    "4",
                    "24"
                ],
                inverse: [
                    "7",
                    "27"
                ],
                hidden: [
                    "8",
                    "28"
                ],
                strike: [
                    "9",
                    "29"
                ],
                black: [
                    "30",
                    "39"
                ],
                red: [
                    "31",
                    "39"
                ],
                green: [
                    "32",
                    "39"
                ],
                yellow: [
                    "33",
                    "39"
                ],
                blue: [
                    "34",
                    "39"
                ],
                magenta: [
                    "35",
                    "39"
                ],
                cyan: [
                    "36",
                    "39"
                ],
                white: [
                    "37",
                    "39"
                ],
                brightblack: [
                    "30;1",
                    "39"
                ],
                brightred: [
                    "31;1",
                    "39"
                ],
                brightgreen: [
                    "32;1",
                    "39"
                ],
                brightyellow: [
                    "33;1",
                    "39"
                ],
                brightblue: [
                    "34;1",
                    "39"
                ],
                brightmagenta: [
                    "35;1",
                    "39"
                ],
                brightcyan: [
                    "36;1",
                    "39"
                ],
                brightwhite: [
                    "37;1",
                    "39"
                ],
                grey: [
                    "90",
                    "39"
                ]
            }, styles = {
                special: "cyan",
                number: "yellow",
                bigint: "yellow",
                boolean: "yellow",
                undefined: "grey",
                null: "bold",
                string: "green",
                symbol: "green",
                date: "magenta",
                regexp: "red"
            }, truncator = "\u2026";
            function colorise(value, styleType) {
                var color = ansiColors[styles[styleType]] || ansiColors[styleType];
                return color ? "\x1B[".concat(color[0], "m").concat(String(value), "\x1B[").concat(color[1], "m") : String(value);
            }
            function normaliseOptions() {
                var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, _ref$showHidden = _ref.showHidden, showHidden = _ref$showHidden === void 0 ? !1 : _ref$showHidden, _ref$depth = _ref.depth, depth = _ref$depth === void 0 ? 2 : _ref$depth, _ref$colors = _ref.colors, colors = _ref$colors === void 0 ? !1 : _ref$colors, _ref$customInspect = _ref.customInspect, customInspect = _ref$customInspect === void 0 ? !0 : _ref$customInspect, _ref$showProxy = _ref.showProxy, showProxy = _ref$showProxy === void 0 ? !1 : _ref$showProxy, _ref$maxArrayLength = _ref.maxArrayLength, maxArrayLength = _ref$maxArrayLength === void 0 ? 1 / 0 : _ref$maxArrayLength, _ref$breakLength = _ref.breakLength, breakLength = _ref$breakLength === void 0 ? 1 / 0 : _ref$breakLength, _ref$seen = _ref.seen, seen2 = _ref$seen === void 0 ? [] : _ref$seen, _ref$truncate = _ref.truncate, truncate2 = _ref$truncate === void 0 ? 1 / 0 : _ref$truncate, _ref$stylize = _ref.stylize, stylize = _ref$stylize === void 0 ? String : _ref$stylize, options = {
                    showHidden: !!showHidden,
                    depth: Number(depth),
                    colors: !!colors,
                    customInspect: !!customInspect,
                    showProxy: !!showProxy,
                    maxArrayLength: Number(maxArrayLength),
                    breakLength: Number(breakLength),
                    truncate: Number(truncate2),
                    seen: seen2,
                    stylize
                };
                return options.colors && (options.stylize = colorise), options;
            }
            function truncate(string2, length) {
                var tail = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : truncator;
                string2 = String(string2);
                var tailLength = tail.length, stringLength = string2.length;
                return tailLength > length && stringLength > tailLength ? tail : stringLength > length && stringLength > tailLength ? "".concat(string2.slice(0, length - tailLength)).concat(tail) : string2;
            }
            function inspectList(list, options, inspectItem) {
                var separator = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : ", ";
                inspectItem = inspectItem || options.inspect;
                var size = list.length;
                if (size === 0) return "";
                for(var originalLength = options.truncate, output = "", peek = "", truncated = "", i = 0; i < size; i += 1){
                    var last = i + 1 === list.length, secondToLast = i + 2 === list.length;
                    truncated = "".concat(truncator, "(").concat(list.length - i, ")");
                    var value = list[i];
                    options.truncate = originalLength - output.length - (last ? 0 : separator.length);
                    var string2 = peek || inspectItem(value, options) + (last ? "" : separator), nextLength = output.length + string2.length, truncatedLength = nextLength + truncated.length;
                    if (last && nextLength > originalLength && output.length + truncated.length <= originalLength || !last && !secondToLast && truncatedLength > originalLength || (peek = last ? "" : inspectItem(list[i + 1], options) + (secondToLast ? "" : separator), !last && secondToLast && truncatedLength > originalLength && nextLength + peek.length > originalLength)) break;
                    if (output += string2, !last && !secondToLast && nextLength + peek.length >= originalLength) {
                        truncated = "".concat(truncator, "(").concat(list.length - i - 1, ")");
                        break;
                    }
                    truncated = "";
                }
                return "".concat(output).concat(truncated);
            }
            function quoteComplexKey(key) {
                return key.match(/^[a-zA-Z_][a-zA-Z_0-9]*$/) ? key : JSON.stringify(key).replace(/'/g, "\\'").replace(/\\"/g, '"').replace(/(^"|"$)/g, "'");
            }
            function inspectProperty(_ref2, options) {
                var _ref3 = _slicedToArray(_ref2, 2), key = _ref3[0], value = _ref3[1];
                return options.truncate -= 2, typeof key == "string" ? key = quoteComplexKey(key) : typeof key != "number" && (key = "[".concat(options.inspect(key, options), "]")), options.truncate -= key.length, value = options.inspect(value, options), "".concat(key, ": ").concat(value);
            }
            function inspectArray(array, options) {
                var nonIndexProperties = Object.keys(array).slice(array.length);
                if (!array.length && !nonIndexProperties.length) return "[]";
                options.truncate -= 4;
                var listContents = inspectList(array, options);
                options.truncate -= listContents.length;
                var propertyContents = "";
                return nonIndexProperties.length && (propertyContents = inspectList(nonIndexProperties.map(function(key) {
                    return [
                        key,
                        array[key]
                    ];
                }), options, inspectProperty)), "[ ".concat(listContents).concat(propertyContents ? ", ".concat(propertyContents) : "", " ]");
            }
            var toString = Function.prototype.toString, functionNameMatch = /\s*function(?:\s|\s*\/\*[^(?:*\/)]+\*\/\s*)*([^\s\(\/]+)/, maxFunctionSourceLength = 512;
            function getFuncName(aFunc) {
                if (typeof aFunc != "function") return null;
                var name = "";
                if (typeof Function.prototype.name > "u" && typeof aFunc.name > "u") {
                    var functionSource = toString.call(aFunc);
                    if (functionSource.indexOf("(") > maxFunctionSourceLength) return name;
                    var match = functionSource.match(functionNameMatch);
                    match && (name = match[1]);
                } else name = aFunc.name;
                return name;
            }
            var getFuncName_1 = getFuncName, getArrayName = function(array) {
                return typeof Buffer == "function" && array instanceof Buffer ? "Buffer" : array[Symbol.toStringTag] ? array[Symbol.toStringTag] : getFuncName_1(array.constructor);
            };
            function inspectTypedArray(array, options) {
                var name = getArrayName(array);
                options.truncate -= name.length + 4;
                var nonIndexProperties = Object.keys(array).slice(array.length);
                if (!array.length && !nonIndexProperties.length) return "".concat(name, "[]");
                for(var output = "", i = 0; i < array.length; i++){
                    var string2 = "".concat(options.stylize(truncate(array[i], options.truncate), "number")).concat(i === array.length - 1 ? "" : ", ");
                    if (options.truncate -= string2.length, array[i] !== array.length && options.truncate <= 3) {
                        output += "".concat(truncator, "(").concat(array.length - array[i] + 1, ")");
                        break;
                    }
                    output += string2;
                }
                var propertyContents = "";
                return nonIndexProperties.length && (propertyContents = inspectList(nonIndexProperties.map(function(key) {
                    return [
                        key,
                        array[key]
                    ];
                }), options, inspectProperty)), "".concat(name, "[ ").concat(output).concat(propertyContents ? ", ".concat(propertyContents) : "", " ]");
            }
            function inspectDate(dateObject, options) {
                var stringRepresentation = dateObject.toJSON();
                if (stringRepresentation === null) return "Invalid Date";
                var split = stringRepresentation.split("T"), date = split[0];
                return options.stylize("".concat(date, "T").concat(truncate(split[1], options.truncate - date.length - 1)), "date");
            }
            function inspectFunction(func, options) {
                var name = getFuncName_1(func);
                return name ? options.stylize("[Function ".concat(truncate(name, options.truncate - 11), "]"), "special") : options.stylize("[Function]", "special");
            }
            function inspectMapEntry(_ref, options) {
                var _ref2 = _slicedToArray(_ref, 2), key = _ref2[0], value = _ref2[1];
                return options.truncate -= 4, key = options.inspect(key, options), options.truncate -= key.length, value = options.inspect(value, options), "".concat(key, " => ").concat(value);
            }
            function mapToEntries(map) {
                var entries = [];
                return map.forEach(function(value, key) {
                    entries.push([
                        key,
                        value
                    ]);
                }), entries;
            }
            function inspectMap(map, options) {
                var size = map.size - 1;
                return size <= 0 ? "Map{}" : (options.truncate -= 7, "Map{ ".concat(inspectList(mapToEntries(map), options, inspectMapEntry), " }"));
            }
            var isNaN2 = Number.isNaN || function(i) {
                return i !== i;
            };
            function inspectNumber(number, options) {
                return isNaN2(number) ? options.stylize("NaN", "number") : number === 1 / 0 ? options.stylize("Infinity", "number") : number === -1 / 0 ? options.stylize("-Infinity", "number") : number === 0 ? options.stylize(1 / number === 1 / 0 ? "+0" : "-0", "number") : options.stylize(truncate(number, options.truncate), "number");
            }
            function inspectBigInt(number, options) {
                var nums = truncate(number.toString(), options.truncate - 1);
                return nums !== truncator && (nums += "n"), options.stylize(nums, "bigint");
            }
            function inspectRegExp(value, options) {
                var flags = value.toString().split("/")[2], sourceLength = options.truncate - (2 + flags.length), source = value.source;
                return options.stylize("/".concat(truncate(source, sourceLength), "/").concat(flags), "regexp");
            }
            function arrayFromSet(set) {
                var values = [];
                return set.forEach(function(value) {
                    values.push(value);
                }), values;
            }
            function inspectSet(set, options) {
                return set.size === 0 ? "Set{}" : (options.truncate -= 7, "Set{ ".concat(inspectList(arrayFromSet(set), options), " }"));
            }
            var stringEscapeChars = new RegExp("['\\u0000-\\u001f\\u007f-\\u009f\\u00ad\\u0600-\\u0604\\u070f\\u17b4\\u17b5\\u200c-\\u200f\\u2028-\\u202f\\u2060-\\u206f\\ufeff\\ufff0-\\uffff]", "g"), escapeCharacters = {
                "\b": "\\b",
                "	": "\\t",
                "\n": "\\n",
                "\f": "\\f",
                "\r": "\\r",
                "'": "\\'",
                "\\": "\\\\"
            }, hex = 16, unicodeLength = 4;
            function escape(char) {
                return escapeCharacters[char] || "\\u".concat("0000".concat(char.charCodeAt(0).toString(hex)).slice(-unicodeLength));
            }
            function inspectString(string2, options) {
                return stringEscapeChars.test(string2) && (string2 = string2.replace(stringEscapeChars, escape)), options.stylize("'".concat(truncate(string2, options.truncate - 2), "'"), "string");
            }
            function inspectSymbol(value) {
                return "description" in Symbol.prototype ? value.description ? "Symbol(".concat(value.description, ")") : "Symbol()" : value.toString();
            }
            var getPromiseValue = function() {
                return "Promise{\u2026}";
            };
            try {
                var _process$binding = process.binding("util"), getPromiseDetails = _process$binding.getPromiseDetails, kPending = _process$binding.kPending, kRejected = _process$binding.kRejected;
                Array.isArray(getPromiseDetails(Promise.resolve())) && (getPromiseValue = function(value, options) {
                    var _getPromiseDetails = getPromiseDetails(value), _getPromiseDetails2 = _slicedToArray(_getPromiseDetails, 2), state = _getPromiseDetails2[0], innerValue = _getPromiseDetails2[1];
                    return state === kPending ? "Promise{<pending>}" : "Promise".concat(state === kRejected ? "!" : "", "{").concat(options.inspect(innerValue, options), "}");
                });
            } catch  {}
            var inspectPromise = getPromiseValue;
            function inspectObject(object, options) {
                var properties = Object.getOwnPropertyNames(object), symbols = Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols(object) : [];
                if (properties.length === 0 && symbols.length === 0) return "{}";
                if (options.truncate -= 4, options.seen = options.seen || [], options.seen.indexOf(object) >= 0) return "[Circular]";
                options.seen.push(object);
                var propertyContents = inspectList(properties.map(function(key) {
                    return [
                        key,
                        object[key]
                    ];
                }), options, inspectProperty), symbolContents = inspectList(symbols.map(function(key) {
                    return [
                        key,
                        object[key]
                    ];
                }), options, inspectProperty);
                options.seen.pop();
                var sep = "";
                return propertyContents && symbolContents && (sep = ", "), "{ ".concat(propertyContents).concat(sep).concat(symbolContents, " }");
            }
            var toStringTag = typeof Symbol < "u" && Symbol.toStringTag ? Symbol.toStringTag : !1;
            function inspectClass(value, options) {
                var name = "";
                return toStringTag && toStringTag in value && (name = value[toStringTag]), name = name || getFuncName_1(value.constructor), (!name || name === "_class") && (name = "<Anonymous Class>"), options.truncate -= name.length, "".concat(name).concat(inspectObject(value, options));
            }
            function inspectArguments(args, options) {
                return args.length === 0 ? "Arguments[]" : (options.truncate -= 13, "Arguments[ ".concat(inspectList(args, options), " ]"));
            }
            var errorKeys = [
                "stack",
                "line",
                "column",
                "name",
                "message",
                "fileName",
                "lineNumber",
                "columnNumber",
                "number",
                "description"
            ];
            function inspectObject$1(error, options) {
                var properties = Object.getOwnPropertyNames(error).filter(function(key) {
                    return errorKeys.indexOf(key) === -1;
                }), name = error.name;
                options.truncate -= name.length;
                var message = "";
                typeof error.message == "string" ? message = truncate(error.message, options.truncate) : properties.unshift("message"), message = message ? ": ".concat(message) : "", options.truncate -= message.length + 5;
                var propertyContents = inspectList(properties.map(function(key) {
                    return [
                        key,
                        error[key]
                    ];
                }), options, inspectProperty);
                return "".concat(name).concat(message).concat(propertyContents ? " { ".concat(propertyContents, " }") : "");
            }
            function inspectAttribute(_ref, options) {
                var _ref2 = _slicedToArray(_ref, 2), key = _ref2[0], value = _ref2[1];
                return options.truncate -= 3, value ? "".concat(options.stylize(key, "yellow"), "=").concat(options.stylize('"'.concat(value, '"'), "string")) : "".concat(options.stylize(key, "yellow"));
            }
            function inspectHTMLCollection(collection, options) {
                return inspectList(collection, options, inspectHTML, `
`);
            }
            function inspectHTML(element, options) {
                var properties = element.getAttributeNames(), name = element.tagName.toLowerCase(), head = options.stylize("<".concat(name), "special"), headClose = options.stylize(">", "special"), tail = options.stylize("</".concat(name, ">"), "special");
                options.truncate -= name.length * 2 + 5;
                var propertyContents = "";
                properties.length > 0 && (propertyContents += " ", propertyContents += inspectList(properties.map(function(key) {
                    return [
                        key,
                        element.getAttribute(key)
                    ];
                }), options, inspectAttribute, " ")), options.truncate -= propertyContents.length;
                var truncate2 = options.truncate, children = inspectHTMLCollection(element.children, options);
                return children && children.length > truncate2 && (children = "".concat(truncator, "(").concat(element.children.length, ")")), "".concat(head).concat(propertyContents).concat(headClose).concat(children).concat(tail);
            }
            var symbolsSupported = typeof Symbol == "function" && typeof Symbol.for == "function", chaiInspect = symbolsSupported ? Symbol.for("chai/inspect") : "@@chai/inspect", nodeInspect = !1;
            try {
                var nodeUtil = __require2("util");
                nodeInspect = nodeUtil.inspect ? nodeUtil.inspect.custom : !1;
            } catch  {
                nodeInspect = !1;
            }
            function FakeMap() {
                this.key = "chai/loupe__" + Math.random() + Date.now();
            }
            FakeMap.prototype = {
                get: function(key) {
                    return key[this.key];
                },
                has: function(key) {
                    return this.key in key;
                },
                set: function(key, value) {
                    Object.isExtensible(key) && Object.defineProperty(key, this.key, {
                        value,
                        configurable: !0
                    });
                }
            };
            var constructorMap = new (typeof WeakMap == "function" ? WeakMap : FakeMap), stringTagMap = {}, baseTypesMap = {
                undefined: function(value, options) {
                    return options.stylize("undefined", "undefined");
                },
                null: function(value, options) {
                    return options.stylize(null, "null");
                },
                boolean: function(value, options) {
                    return options.stylize(value, "boolean");
                },
                Boolean: function(value, options) {
                    return options.stylize(value, "boolean");
                },
                number: inspectNumber,
                Number: inspectNumber,
                bigint: inspectBigInt,
                BigInt: inspectBigInt,
                string: inspectString,
                String: inspectString,
                function: inspectFunction,
                Function: inspectFunction,
                symbol: inspectSymbol,
                Symbol: inspectSymbol,
                Array: inspectArray,
                Date: inspectDate,
                Map: inspectMap,
                Set: inspectSet,
                RegExp: inspectRegExp,
                Promise: inspectPromise,
                WeakSet: function(value, options) {
                    return options.stylize("WeakSet{\u2026}", "special");
                },
                WeakMap: function(value, options) {
                    return options.stylize("WeakMap{\u2026}", "special");
                },
                Arguments: inspectArguments,
                Int8Array: inspectTypedArray,
                Uint8Array: inspectTypedArray,
                Uint8ClampedArray: inspectTypedArray,
                Int16Array: inspectTypedArray,
                Uint16Array: inspectTypedArray,
                Int32Array: inspectTypedArray,
                Uint32Array: inspectTypedArray,
                Float32Array: inspectTypedArray,
                Float64Array: inspectTypedArray,
                Generator: function() {
                    return "";
                },
                DataView: function() {
                    return "";
                },
                ArrayBuffer: function() {
                    return "";
                },
                Error: inspectObject$1,
                HTMLCollection: inspectHTMLCollection,
                NodeList: inspectHTMLCollection
            }, inspectCustom = function(value, options, type) {
                return chaiInspect in value && typeof value[chaiInspect] == "function" ? value[chaiInspect](options) : nodeInspect && nodeInspect in value && typeof value[nodeInspect] == "function" ? value[nodeInspect](options.depth, options) : "inspect" in value && typeof value.inspect == "function" ? value.inspect(options.depth, options) : "constructor" in value && constructorMap.has(value.constructor) ? constructorMap.get(value.constructor)(value, options) : stringTagMap[type] ? stringTagMap[type](value, options) : "";
            }, toString$1 = Object.prototype.toString;
            function inspect2(value, options) {
                options = normaliseOptions(options), options.inspect = inspect2;
                var _options = options, customInspect = _options.customInspect, type = value === null ? "null" : _typeof(value);
                if (type === "object" && (type = toString$1.call(value).slice(8, -1)), baseTypesMap[type]) return baseTypesMap[type](value, options);
                if (customInspect && value) {
                    var output = inspectCustom(value, options, type);
                    if (output) return typeof output == "string" ? output : inspect2(output, options);
                }
                var proto = value ? Object.getPrototypeOf(value) : !1;
                return proto === Object.prototype || proto === null ? inspectObject(value, options) : value && typeof HTMLElement == "function" && value instanceof HTMLElement ? inspectHTML(value, options) : "constructor" in value ? value.constructor !== Object ? inspectClass(value, options) : inspectObject(value, options) : value === Object(value) ? inspectObject(value, options) : options.stylize(String(value), type);
            }
            function registerConstructor(constructor, inspector) {
                return constructorMap.has(constructor) ? !1 : (constructorMap.set(constructor, inspector), !0);
            }
            function registerStringTag(stringTag, inspector) {
                return stringTag in stringTagMap ? !1 : (stringTagMap[stringTag] = inspector, !0);
            }
            var custom = chaiInspect;
            exports2.custom = custom, exports2.default = inspect2, exports2.inspect = inspect2, exports2.registerConstructor = registerConstructor, exports2.registerStringTag = registerStringTag, Object.defineProperty(exports2, "__esModule", {
                value: !0
            });
        });
    }
}), import_pretty_format = __toESM(require_build(), 1), diff$1 = __toESM(require_build2(), 1), SAFE_COLORS_SYMBOL = Symbol("vitest:SAFE_COLORS"), colorsMap = {
    bold: [
        "\x1B[1m",
        "\x1B[22m",
        "\x1B[22m\x1B[1m"
    ],
    dim: [
        "\x1B[2m",
        "\x1B[22m",
        "\x1B[22m\x1B[2m"
    ],
    italic: [
        "\x1B[3m",
        "\x1B[23m"
    ],
    underline: [
        "\x1B[4m",
        "\x1B[24m"
    ],
    inverse: [
        "\x1B[7m",
        "\x1B[27m"
    ],
    hidden: [
        "\x1B[8m",
        "\x1B[28m"
    ],
    strikethrough: [
        "\x1B[9m",
        "\x1B[29m"
    ],
    black: [
        "\x1B[30m",
        "\x1B[39m"
    ],
    red: [
        "\x1B[31m",
        "\x1B[39m"
    ],
    green: [
        "\x1B[32m",
        "\x1B[39m"
    ],
    yellow: [
        "\x1B[33m",
        "\x1B[39m"
    ],
    blue: [
        "\x1B[34m",
        "\x1B[39m"
    ],
    magenta: [
        "\x1B[35m",
        "\x1B[39m"
    ],
    cyan: [
        "\x1B[36m",
        "\x1B[39m"
    ],
    white: [
        "\x1B[37m",
        "\x1B[39m"
    ],
    gray: [
        "\x1B[90m",
        "\x1B[39m"
    ],
    bgBlack: [
        "\x1B[40m",
        "\x1B[49m"
    ],
    bgRed: [
        "\x1B[41m",
        "\x1B[49m"
    ],
    bgGreen: [
        "\x1B[42m",
        "\x1B[49m"
    ],
    bgYellow: [
        "\x1B[43m",
        "\x1B[49m"
    ],
    bgBlue: [
        "\x1B[44m",
        "\x1B[49m"
    ],
    bgMagenta: [
        "\x1B[45m",
        "\x1B[49m"
    ],
    bgCyan: [
        "\x1B[46m",
        "\x1B[49m"
    ],
    bgWhite: [
        "\x1B[47m",
        "\x1B[49m"
    ]
}, colorsEntries = Object.entries(colorsMap);
function string(str) {
    return String(str);
}
string.open = "";
string.close = "";
var defaultColors = colorsEntries.reduce((acc, [key])=>(acc[key] = string, acc), {
    isColorSupported: !1
});
function getColors() {
    return globalThis[SAFE_COLORS_SYMBOL] || defaultColors;
}
function getType(value) {
    if (value === void 0) return "undefined";
    if (value === null) return "null";
    if (Array.isArray(value)) return "array";
    if (typeof value == "boolean") return "boolean";
    if (typeof value == "function") return "function";
    if (typeof value == "number") return "number";
    if (typeof value == "string") return "string";
    if (typeof value == "bigint") return "bigint";
    if (typeof value == "object") {
        if (value != null) {
            if (value.constructor === RegExp) return "regexp";
            if (value.constructor === Map) return "map";
            if (value.constructor === Set) return "set";
            if (value.constructor === Date) return "date";
        }
        return "object";
    } else if (typeof value == "symbol") return "symbol";
    throw new Error(`value of unknown type: ${value}`);
}
var DIFF_DELETE = -1, DIFF_INSERT = 1, DIFF_EQUAL = 0, Diff = class {
    0;
    1;
    constructor(op, text){
        this[0] = op, this[1] = text;
    }
}, NO_DIFF_MESSAGE = "Compared values have no visual difference.", SIMILAR_MESSAGE = "Compared values serialize to the same structure.\nPrinting internal object structure without calling `toJSON` instead.";
function formatTrailingSpaces(line, trailingSpaceFormatter) {
    return line.replace(/\s+$/, (match)=>trailingSpaceFormatter(match));
}
function printDiffLine(line, isFirstOrLast, color, indicator, trailingSpaceFormatter, emptyFirstOrLastLinePlaceholder) {
    return line.length !== 0 ? color(`${indicator} ${formatTrailingSpaces(line, trailingSpaceFormatter)}`) : indicator !== " " ? color(indicator) : isFirstOrLast && emptyFirstOrLastLinePlaceholder.length !== 0 ? color(`${indicator} ${emptyFirstOrLastLinePlaceholder}`) : "";
}
function printDeleteLine(line, isFirstOrLast, { aColor, aIndicator, changeLineTrailingSpaceColor, emptyFirstOrLastLinePlaceholder }) {
    return printDiffLine(line, isFirstOrLast, aColor, aIndicator, changeLineTrailingSpaceColor, emptyFirstOrLastLinePlaceholder);
}
function printInsertLine(line, isFirstOrLast, { bColor, bIndicator, changeLineTrailingSpaceColor, emptyFirstOrLastLinePlaceholder }) {
    return printDiffLine(line, isFirstOrLast, bColor, bIndicator, changeLineTrailingSpaceColor, emptyFirstOrLastLinePlaceholder);
}
function printCommonLine(line, isFirstOrLast, { commonColor, commonIndicator, commonLineTrailingSpaceColor, emptyFirstOrLastLinePlaceholder }) {
    return printDiffLine(line, isFirstOrLast, commonColor, commonIndicator, commonLineTrailingSpaceColor, emptyFirstOrLastLinePlaceholder);
}
function createPatchMark(aStart, aEnd, bStart, bEnd, { patchColor }) {
    return patchColor(`@@ -${aStart + 1},${aEnd - aStart} +${bStart + 1},${bEnd - bStart} @@`);
}
function joinAlignedDiffsNoExpand(diffs, options) {
    let iLength = diffs.length, nContextLines = options.contextLines, nContextLines2 = nContextLines + nContextLines, jLength = iLength, hasExcessAtStartOrEnd = !1, nExcessesBetweenChanges = 0, i = 0;
    for(; i !== iLength;){
        let iStart = i;
        for(; i !== iLength && diffs[i][0] === DIFF_EQUAL;)i += 1;
        if (iStart !== i) {
            if (iStart === 0) i > nContextLines && (jLength -= i - nContextLines, hasExcessAtStartOrEnd = !0);
            else if (i === iLength) {
                let n = i - iStart;
                n > nContextLines && (jLength -= n - nContextLines, hasExcessAtStartOrEnd = !0);
            } else {
                let n = i - iStart;
                n > nContextLines2 && (jLength -= n - nContextLines2, nExcessesBetweenChanges += 1);
            }
        }
        for(; i !== iLength && diffs[i][0] !== DIFF_EQUAL;)i += 1;
    }
    let hasPatch = nExcessesBetweenChanges !== 0 || hasExcessAtStartOrEnd;
    nExcessesBetweenChanges !== 0 ? jLength += nExcessesBetweenChanges + 1 : hasExcessAtStartOrEnd && (jLength += 1);
    let jLast = jLength - 1, lines = [], jPatchMark = 0;
    hasPatch && lines.push("");
    let aStart = 0, bStart = 0, aEnd = 0, bEnd = 0, pushCommonLine = (line)=>{
        let j = lines.length;
        lines.push(printCommonLine(line, j === 0 || j === jLast, options)), aEnd += 1, bEnd += 1;
    }, pushDeleteLine = (line)=>{
        let j = lines.length;
        lines.push(printDeleteLine(line, j === 0 || j === jLast, options)), aEnd += 1;
    }, pushInsertLine = (line)=>{
        let j = lines.length;
        lines.push(printInsertLine(line, j === 0 || j === jLast, options)), bEnd += 1;
    };
    for(i = 0; i !== iLength;){
        let iStart = i;
        for(; i !== iLength && diffs[i][0] === DIFF_EQUAL;)i += 1;
        if (iStart !== i) {
            if (iStart === 0) {
                i > nContextLines && (iStart = i - nContextLines, aStart = iStart, bStart = iStart, aEnd = aStart, bEnd = bStart);
                for(let iCommon = iStart; iCommon !== i; iCommon += 1)pushCommonLine(diffs[iCommon][1]);
            } else if (i === iLength) {
                let iEnd = i - iStart > nContextLines ? iStart + nContextLines : i;
                for(let iCommon = iStart; iCommon !== iEnd; iCommon += 1)pushCommonLine(diffs[iCommon][1]);
            } else {
                let nCommon = i - iStart;
                if (nCommon > nContextLines2) {
                    let iEnd = iStart + nContextLines;
                    for(let iCommon = iStart; iCommon !== iEnd; iCommon += 1)pushCommonLine(diffs[iCommon][1]);
                    lines[jPatchMark] = createPatchMark(aStart, aEnd, bStart, bEnd, options), jPatchMark = lines.length, lines.push("");
                    let nOmit = nCommon - nContextLines2;
                    aStart = aEnd + nOmit, bStart = bEnd + nOmit, aEnd = aStart, bEnd = bStart;
                    for(let iCommon = i - nContextLines; iCommon !== i; iCommon += 1)pushCommonLine(diffs[iCommon][1]);
                } else for(let iCommon = iStart; iCommon !== i; iCommon += 1)pushCommonLine(diffs[iCommon][1]);
            }
        }
        for(; i !== iLength && diffs[i][0] === DIFF_DELETE;)pushDeleteLine(diffs[i][1]), i += 1;
        for(; i !== iLength && diffs[i][0] === DIFF_INSERT;)pushInsertLine(diffs[i][1]), i += 1;
    }
    return hasPatch && (lines[jPatchMark] = createPatchMark(aStart, aEnd, bStart, bEnd, options)), lines.join(`
`);
}
function joinAlignedDiffsExpand(diffs, options) {
    return diffs.map((diff2, i, diffs2)=>{
        let line = diff2[1], isFirstOrLast = i === 0 || i === diffs2.length - 1;
        switch(diff2[0]){
            case DIFF_DELETE:
                return printDeleteLine(line, isFirstOrLast, options);
            case DIFF_INSERT:
                return printInsertLine(line, isFirstOrLast, options);
            default:
                return printCommonLine(line, isFirstOrLast, options);
        }
    }).join(`
`);
}
var noColor = (string2)=>string2, DIFF_CONTEXT_DEFAULT = 5;
function getDefaultOptions() {
    let c = getColors();
    return {
        aAnnotation: "Expected",
        aColor: c.green,
        aIndicator: "-",
        bAnnotation: "Received",
        bColor: c.red,
        bIndicator: "+",
        changeColor: c.inverse,
        changeLineTrailingSpaceColor: noColor,
        commonColor: c.dim,
        commonIndicator: " ",
        commonLineTrailingSpaceColor: noColor,
        compareKeys: void 0,
        contextLines: DIFF_CONTEXT_DEFAULT,
        emptyFirstOrLastLinePlaceholder: "",
        expand: !0,
        includeChangeCounts: !1,
        omitAnnotationLines: !1,
        patchColor: c.yellow
    };
}
function getCompareKeys(compareKeys) {
    return compareKeys && typeof compareKeys == "function" ? compareKeys : void 0;
}
function getContextLines(contextLines) {
    return typeof contextLines == "number" && Number.isSafeInteger(contextLines) && contextLines >= 0 ? contextLines : DIFF_CONTEXT_DEFAULT;
}
function normalizeDiffOptions(options = {}) {
    return {
        ...getDefaultOptions(),
        ...options,
        compareKeys: getCompareKeys(options.compareKeys),
        contextLines: getContextLines(options.contextLines)
    };
}
function isEmptyString(lines) {
    return lines.length === 1 && lines[0].length === 0;
}
function countChanges(diffs) {
    let a = 0, b = 0;
    return diffs.forEach((diff2)=>{
        switch(diff2[0]){
            case DIFF_DELETE:
                a += 1;
                break;
            case DIFF_INSERT:
                b += 1;
                break;
        }
    }), {
        a,
        b
    };
}
function printAnnotation({ aAnnotation, aColor, aIndicator, bAnnotation, bColor, bIndicator, includeChangeCounts, omitAnnotationLines }, changeCounts) {
    if (omitAnnotationLines) return "";
    let aRest = "", bRest = "";
    if (includeChangeCounts) {
        let aCount = String(changeCounts.a), bCount = String(changeCounts.b), baAnnotationLengthDiff = bAnnotation.length - aAnnotation.length, aAnnotationPadding = " ".repeat(Math.max(0, baAnnotationLengthDiff)), bAnnotationPadding = " ".repeat(Math.max(0, -baAnnotationLengthDiff)), baCountLengthDiff = bCount.length - aCount.length, aCountPadding = " ".repeat(Math.max(0, baCountLengthDiff)), bCountPadding = " ".repeat(Math.max(0, -baCountLengthDiff));
        aRest = `${aAnnotationPadding}  ${aIndicator} ${aCountPadding}${aCount}`, bRest = `${bAnnotationPadding}  ${bIndicator} ${bCountPadding}${bCount}`;
    }
    let a = `${aIndicator} ${aAnnotation}${aRest}`, b = `${bIndicator} ${bAnnotation}${bRest}`;
    return `${aColor(a)}
${bColor(b)}

`;
}
function printDiffLines(diffs, options) {
    return printAnnotation(options, countChanges(diffs)) + (options.expand ? joinAlignedDiffsExpand(diffs, options) : joinAlignedDiffsNoExpand(diffs, options));
}
function diffLinesUnified(aLines, bLines, options) {
    return printDiffLines(diffLinesRaw(isEmptyString(aLines) ? [] : aLines, isEmptyString(bLines) ? [] : bLines), normalizeDiffOptions(options));
}
function diffLinesUnified2(aLinesDisplay, bLinesDisplay, aLinesCompare, bLinesCompare, options) {
    if (isEmptyString(aLinesDisplay) && isEmptyString(aLinesCompare) && (aLinesDisplay = [], aLinesCompare = []), isEmptyString(bLinesDisplay) && isEmptyString(bLinesCompare) && (bLinesDisplay = [], bLinesCompare = []), aLinesDisplay.length !== aLinesCompare.length || bLinesDisplay.length !== bLinesCompare.length) return diffLinesUnified(aLinesDisplay, bLinesDisplay, options);
    let diffs = diffLinesRaw(aLinesCompare, bLinesCompare), aIndex = 0, bIndex = 0;
    return diffs.forEach((diff2)=>{
        switch(diff2[0]){
            case DIFF_DELETE:
                diff2[1] = aLinesDisplay[aIndex], aIndex += 1;
                break;
            case DIFF_INSERT:
                diff2[1] = bLinesDisplay[bIndex], bIndex += 1;
                break;
            default:
                diff2[1] = bLinesDisplay[bIndex], aIndex += 1, bIndex += 1;
        }
    }), printDiffLines(diffs, normalizeDiffOptions(options));
}
function diffLinesRaw(aLines, bLines) {
    let aLength = aLines.length, bLength = bLines.length, isCommon = (aIndex2, bIndex2)=>aLines[aIndex2] === bLines[bIndex2], diffs = [], aIndex = 0, bIndex = 0, foundSubsequence = (nCommon, aCommon, bCommon)=>{
        for(; aIndex !== aCommon; aIndex += 1)diffs.push(new Diff(DIFF_DELETE, aLines[aIndex]));
        for(; bIndex !== bCommon; bIndex += 1)diffs.push(new Diff(DIFF_INSERT, bLines[bIndex]));
        for(; nCommon !== 0; nCommon -= 1, aIndex += 1, bIndex += 1)diffs.push(new Diff(DIFF_EQUAL, bLines[bIndex]));
    };
    for((diff$1.default.default || diff$1.default)(aLength, bLength, isCommon, foundSubsequence); aIndex !== aLength; aIndex += 1)diffs.push(new Diff(DIFF_DELETE, aLines[aIndex]));
    for(; bIndex !== bLength; bIndex += 1)diffs.push(new Diff(DIFF_INSERT, bLines[bIndex]));
    return diffs;
}
function getCommonMessage(message, options) {
    let { commonColor } = normalizeDiffOptions(options);
    return commonColor(message);
}
var { AsymmetricMatcher, DOMCollection, DOMElement, Immutable, ReactElement, ReactTestComponent } = import_pretty_format.plugins, PLUGINS = [
    ReactTestComponent,
    ReactElement,
    DOMElement,
    DOMCollection,
    Immutable,
    AsymmetricMatcher
], FORMAT_OPTIONS = {
    plugins: PLUGINS
}, FALLBACK_FORMAT_OPTIONS = {
    callToJSON: !1,
    maxDepth: 10,
    plugins: PLUGINS
};
function diff(a, b, options) {
    if (Object.is(a, b)) return "";
    let aType = getType(a), expectedType = aType, omitDifference = !1;
    if (aType === "object" && typeof a.asymmetricMatch == "function") {
        if (a.$$typeof !== Symbol.for("jest.asymmetricMatcher") || typeof a.getExpectedType != "function") return null;
        expectedType = a.getExpectedType(), omitDifference = expectedType === "string";
    }
    if (expectedType !== getType(b)) {
        let { aAnnotation, aColor, aIndicator, bAnnotation, bColor, bIndicator } = normalizeDiffOptions(options), formatOptions = getFormatOptions(FALLBACK_FORMAT_OPTIONS, options), aDisplay = (0, import_pretty_format.format)(a, formatOptions), bDisplay = (0, import_pretty_format.format)(b, formatOptions), aDiff = `${aColor(`${aIndicator} ${aAnnotation}:`)} 
${aDisplay}`, bDiff = `${bColor(`${bIndicator} ${bAnnotation}:`)} 
${bDisplay}`;
        return `${aDiff}

${bDiff}`;
    }
    if (omitDifference) return null;
    switch(aType){
        case "string":
            return diffLinesUnified(a.split(`
`), b.split(`
`), options);
        case "boolean":
        case "number":
            return comparePrimitive(a, b, options);
        case "map":
            return compareObjects(sortMap(a), sortMap(b), options);
        case "set":
            return compareObjects(sortSet(a), sortSet(b), options);
        default:
            return compareObjects(a, b, options);
    }
}
function comparePrimitive(a, b, options) {
    let aFormat = (0, import_pretty_format.format)(a, FORMAT_OPTIONS), bFormat = (0, import_pretty_format.format)(b, FORMAT_OPTIONS);
    return aFormat === bFormat ? "" : diffLinesUnified(aFormat.split(`
`), bFormat.split(`
`), options);
}
function sortMap(map) {
    return new Map(Array.from(map.entries()).sort());
}
function sortSet(set) {
    return new Set(Array.from(set.values()).sort());
}
function compareObjects(a, b, options) {
    let difference, hasThrown = !1;
    try {
        let formatOptions = getFormatOptions(FORMAT_OPTIONS, options);
        difference = getObjectsDifference(a, b, formatOptions, options);
    } catch  {
        hasThrown = !0;
    }
    let noDiffMessage = getCommonMessage(NO_DIFF_MESSAGE, options);
    if (difference === void 0 || difference === noDiffMessage) {
        let formatOptions = getFormatOptions(FALLBACK_FORMAT_OPTIONS, options);
        difference = getObjectsDifference(a, b, formatOptions, options), difference !== noDiffMessage && !hasThrown && (difference = `${getCommonMessage(SIMILAR_MESSAGE, options)}

${difference}`);
    }
    return difference;
}
function getFormatOptions(formatOptions, options) {
    let { compareKeys } = normalizeDiffOptions(options);
    return {
        ...formatOptions,
        compareKeys
    };
}
function getObjectsDifference(a, b, formatOptions, options) {
    let formatOptionsZeroIndent = {
        ...formatOptions,
        indent: 0
    }, aCompare = (0, import_pretty_format.format)(a, formatOptionsZeroIndent), bCompare = (0, import_pretty_format.format)(b, formatOptionsZeroIndent);
    if (aCompare === bCompare) return getCommonMessage(NO_DIFF_MESSAGE, options);
    {
        let aDisplay = (0, import_pretty_format.format)(a, formatOptions), bDisplay = (0, import_pretty_format.format)(b, formatOptions);
        return diffLinesUnified2(aDisplay.split(`
`), bDisplay.split(`
`), aCompare.split(`
`), bCompare.split(`
`), options);
    }
}
var import_pretty_format2 = __toESM(require_build(), 1), import_loupe = __toESM(require_loupe(), 1), { AsymmetricMatcher: AsymmetricMatcher2, DOMCollection: DOMCollection2, DOMElement: DOMElement2, Immutable: Immutable2, ReactElement: ReactElement2, ReactTestComponent: ReactTestComponent2 } = import_pretty_format2.plugins, PLUGINS2 = [
    ReactTestComponent2,
    ReactElement2,
    DOMElement2,
    DOMCollection2,
    Immutable2,
    AsymmetricMatcher2
];
function stringify(object, maxDepth = 10, { maxLength, ...options } = {}) {
    let MAX_LENGTH = maxLength ?? 1e4, result;
    try {
        result = (0, import_pretty_format2.format)(object, {
            maxDepth,
            escapeString: !1,
            plugins: PLUGINS2,
            ...options
        });
    } catch  {
        result = (0, import_pretty_format2.format)(object, {
            callToJSON: !1,
            maxDepth,
            escapeString: !1,
            plugins: PLUGINS2,
            ...options
        });
    }
    return result.length >= MAX_LENGTH && maxDepth > 1 ? stringify(object, Math.floor(maxDepth / 2)) : result;
}
var formatRegExp = /%[sdjifoOcj%]/g;
function format2(...args) {
    if (typeof args[0] != "string") {
        let objects = [];
        for(let i2 = 0; i2 < args.length; i2++)objects.push(inspect(args[i2], {
            depth: 0,
            colors: !1,
            compact: 3
        }));
        return objects.join(" ");
    }
    let len = args.length, i = 1, template = args[0], str = String(template).replace(formatRegExp, (x)=>{
        if (x === "%%") return "%";
        if (i >= len) return x;
        switch(x){
            case "%s":
                {
                    let value = args[i++];
                    return typeof value == "bigint" ? `${value.toString()}n` : typeof value == "number" && value === 0 && 1 / value < 0 ? "-0" : typeof value == "object" && value !== null ? inspect(value, {
                        depth: 0,
                        colors: !1,
                        compact: 3
                    }) : String(value);
                }
            case "%d":
                {
                    let value = args[i++];
                    return typeof value == "bigint" ? `${value.toString()}n` : Number(value).toString();
                }
            case "%i":
                {
                    let value = args[i++];
                    return typeof value == "bigint" ? `${value.toString()}n` : Number.parseInt(String(value)).toString();
                }
            case "%f":
                return Number.parseFloat(String(args[i++])).toString();
            case "%o":
                return inspect(args[i++], {
                    showHidden: !0,
                    showProxy: !0
                });
            case "%O":
                return inspect(args[i++]);
            case "%c":
                return i++, "";
            case "%j":
                try {
                    return JSON.stringify(args[i++]);
                } catch (err) {
                    let m = err.message;
                    if (m.includes("circular structure") || m.includes("cyclic structures") || m.includes("cyclic object")) return "[Circular]";
                    throw err;
                }
            default:
                return x;
        }
    });
    for(let x = args[i]; i < len; x = args[++i])x === null || typeof x != "object" ? str += ` ${x}` : str += ` ${inspect(x)}`;
    return str;
}
function inspect(obj, options = {}) {
    return options.truncate === 0 && (options.truncate = Number.POSITIVE_INFINITY), (0, import_loupe.inspect)(obj, options);
}
function isFinalObj(obj) {
    return obj === Object.prototype || obj === Function.prototype || obj === RegExp.prototype;
}
function getType2(value) {
    return Object.prototype.toString.apply(value).slice(8, -1);
}
function collectOwnProperties(obj, collector) {
    let collect = typeof collector == "function" ? collector : (key)=>collector.add(key);
    Object.getOwnPropertyNames(obj).forEach(collect), Object.getOwnPropertySymbols(obj).forEach(collect);
}
function getOwnProperties(obj) {
    let ownProps = new Set;
    return isFinalObj(obj) ? [] : (collectOwnProperties(obj, ownProps), Array.from(ownProps));
}
var defaultCloneOptions = {
    forceWritable: !1
};
function deepClone(val, options = defaultCloneOptions) {
    return clone(val, new WeakMap, options);
}
function clone(val, seen2, options = defaultCloneOptions) {
    let k, out;
    if (seen2.has(val)) return seen2.get(val);
    if (Array.isArray(val)) {
        for(out = Array(k = val.length), seen2.set(val, out); k--;)out[k] = clone(val[k], seen2);
        return out;
    }
    if (Object.prototype.toString.call(val) === "[object Object]") {
        out = Object.create(Object.getPrototypeOf(val)), seen2.set(val, out);
        let props = getOwnProperties(val);
        for (let k2 of props){
            let descriptor = Object.getOwnPropertyDescriptor(val, k2);
            if (!descriptor) continue;
            let cloned = clone(val[k2], seen2);
            "get" in descriptor ? Object.defineProperty(out, k2, {
                ...descriptor,
                get () {
                    return cloned;
                }
            }) : Object.defineProperty(out, k2, {
                ...descriptor,
                writable: options.forceWritable ? !0 : descriptor.writable,
                value: cloned
            });
        }
        return out;
    }
    return val;
}
__toESM(require_build(), 1);
__toESM(require_build2(), 1);
__toESM(require_loupe(), 1);
var IS_RECORD_SYMBOL = "@@__IMMUTABLE_RECORD__@@", IS_COLLECTION_SYMBOL = "@@__IMMUTABLE_ITERABLE__@@";
function isImmutable(v) {
    return v && (v[IS_COLLECTION_SYMBOL] || v[IS_RECORD_SYMBOL]);
}
var OBJECT_PROTO = Object.getPrototypeOf({});
function getUnserializableMessage(err) {
    return err instanceof Error ? `<unserializable>: ${err.message}` : typeof err == "string" ? `<unserializable>: ${err}` : "<unserializable>";
}
function serializeError(val, seen2 = new WeakMap) {
    if (!val || typeof val == "string") return val;
    if (typeof val == "function") return `Function<${val.name || "anonymous"}>`;
    if (typeof val == "symbol") return val.toString();
    if (typeof val != "object") return val;
    if (isImmutable(val)) return serializeError(val.toJSON(), seen2);
    if (val instanceof Promise || val.constructor && val.constructor.prototype === "AsyncFunction") return "Promise";
    if (typeof Element < "u" && val instanceof Element) return val.tagName;
    if (typeof val.asymmetricMatch == "function") return `${val.toString()} ${format2(val.sample)}`;
    if (seen2.has(val)) return seen2.get(val);
    if (Array.isArray(val)) {
        let clone2 = new Array(val.length);
        return seen2.set(val, clone2), val.forEach((e, i)=>{
            try {
                clone2[i] = serializeError(e, seen2);
            } catch (err) {
                clone2[i] = getUnserializableMessage(err);
            }
        }), clone2;
    } else {
        let clone2 = Object.create(null);
        seen2.set(val, clone2);
        let obj = val;
        for(; obj && obj !== OBJECT_PROTO;)Object.getOwnPropertyNames(obj).forEach((key)=>{
            if (!(key in clone2)) try {
                clone2[key] = serializeError(val[key], seen2);
            } catch (err) {
                delete clone2[key], clone2[key] = getUnserializableMessage(err);
            }
        }), obj = Object.getPrototypeOf(obj);
        return clone2;
    }
}
function normalizeErrorMessage(message) {
    return message.replace(/__vite_ssr_import_\d+__\./g, "");
}
function processError(err, diffOptions) {
    if (!err || typeof err != "object") return {
        message: err
    };
    if (err.stack && (err.stackStr = String(err.stack)), err.name && (err.nameStr = String(err.name)), err.showDiff || err.showDiff === void 0 && err.expected !== void 0 && err.actual !== void 0) {
        let clonedActual = deepClone(err.actual, {
            forceWritable: !0
        }), clonedExpected = deepClone(err.expected, {
            forceWritable: !0
        }), { replacedActual, replacedExpected } = replaceAsymmetricMatcher(clonedActual, clonedExpected);
        err.diff = diff(replacedExpected, replacedActual, diffOptions);
    }
    typeof err.expected != "string" && (err.expected = stringify(err.expected, 10)), typeof err.actual != "string" && (err.actual = stringify(err.actual, 10));
    try {
        typeof err.message == "string" && (err.message = normalizeErrorMessage(err.message)), typeof err.cause == "object" && typeof err.cause.message == "string" && (err.cause.message = normalizeErrorMessage(err.cause.message));
    } catch  {}
    try {
        return serializeError(err);
    } catch (e) {
        return serializeError(new Error(`Failed to fully serialize error: ${e?.message}
Inner error message: ${err?.message}`));
    }
}
function isAsymmetricMatcher(data) {
    return getType2(data) === "Object" && typeof data.asymmetricMatch == "function";
}
function isReplaceable(obj1, obj2) {
    let obj1Type = getType2(obj1), obj2Type = getType2(obj2);
    return obj1Type === obj2Type && obj1Type === "Object";
}
function replaceAsymmetricMatcher(actual, expected, actualReplaced = new WeakSet, expectedReplaced = new WeakSet) {
    return isReplaceable(actual, expected) ? actualReplaced.has(actual) || expectedReplaced.has(expected) ? {
        replacedActual: actual,
        replacedExpected: expected
    } : (actualReplaced.add(actual), expectedReplaced.add(expected), getOwnProperties(expected).forEach((key)=>{
        let expectedValue = expected[key], actualValue = actual[key];
        if (isAsymmetricMatcher(expectedValue)) expectedValue.asymmetricMatch(actualValue) && (actual[key] = expectedValue);
        else if (isAsymmetricMatcher(actualValue)) actualValue.asymmetricMatch(expectedValue) && (expected[key] = actualValue);
        else if (isReplaceable(actualValue, expectedValue)) {
            let replaced = replaceAsymmetricMatcher(actualValue, expectedValue, actualReplaced, expectedReplaced);
            actual[key] = replaced.replacedActual, expected[key] = replaced.replacedExpected;
        }
    }), {
        replacedActual: actual,
        replacedExpected: expected
    }) : {
        replacedActual: actual,
        replacedExpected: expected
    };
}
var CallStates = ((CallStates2)=>(CallStates2.DONE = "done", CallStates2.ERROR = "error", CallStates2.ACTIVE = "active", CallStates2.WAITING = "waiting", CallStates2))(CallStates || {}), EVENTS = {
    CALL: "storybook/instrumenter/call",
    SYNC: "storybook/instrumenter/sync",
    START: "storybook/instrumenter/start",
    BACK: "storybook/instrumenter/back",
    GOTO: "storybook/instrumenter/goto",
    NEXT: "storybook/instrumenter/next",
    END: "storybook/instrumenter/end"
}, controlsDisabled = {
    start: !1,
    back: !1,
    goto: !1,
    next: !1,
    end: !1
}, alreadyCompletedException = new Error("This function ran after the play function completed. Did you forget to `await` it?"), isObject = (o)=>Object.prototype.toString.call(o) === "[object Object]", isModule = (o)=>Object.prototype.toString.call(o) === "[object Module]", isInstrumentable = (o)=>{
    if (!isObject(o) && !isModule(o)) return !1;
    if (o.constructor === void 0) return !0;
    let proto = o.constructor.prototype;
    return !!isObject(proto);
}, construct = (obj)=>{
    try {
        return new obj.constructor;
    } catch  {
        return {};
    }
}, getInitialState = ()=>({
        renderPhase: void 0,
        isDebugging: !1,
        isPlaying: !1,
        isLocked: !1,
        cursor: 0,
        calls: [],
        shadowCalls: [],
        callRefsByResult: new Map,
        chainedCallIds: new Set,
        ancestors: [],
        playUntil: void 0,
        resolvers: {},
        syncTimeout: void 0
    }), getRetainedState = (state, isDebugging = !1)=>{
    let calls = (isDebugging ? state.shadowCalls : state.calls).filter((call)=>call.retain);
    if (!calls.length) return;
    let callRefsByResult = new Map(Array.from(state.callRefsByResult.entries()).filter(([, ref])=>ref.retain));
    return {
        cursor: calls.length,
        calls,
        callRefsByResult
    };
}, Instrumenter = class {
    constructor(){
        this.initialized = !1, this.channel = (0, _previewApi.addons).getChannel(), this.state = (0, _global.global).window.parent.__STORYBOOK_ADDON_INTERACTIONS_INSTRUMENTER_STATE__ || {};
        let resetState = ({ storyId, isPlaying = !0, isDebugging = !1 })=>{
            let state = this.getState(storyId);
            this.setState(storyId, {
                ...getInitialState(),
                ...getRetainedState(state, isDebugging),
                shadowCalls: isDebugging ? state.shadowCalls : [],
                chainedCallIds: isDebugging ? state.chainedCallIds : new Set,
                playUntil: isDebugging ? state.playUntil : void 0,
                isPlaying,
                isDebugging
            }), this.sync(storyId);
        };
        this.channel.on((0, _coreEvents.FORCE_REMOUNT), resetState), this.channel.on((0, _coreEvents.STORY_RENDER_PHASE_CHANGED), ({ storyId, newPhase })=>{
            let { isDebugging } = this.getState(storyId);
            this.setState(storyId, {
                renderPhase: newPhase
            }), newPhase === "preparing" && isDebugging && resetState({
                storyId
            }), newPhase === "playing" && resetState({
                storyId,
                isDebugging
            }), newPhase === "played" && this.setState(storyId, {
                isLocked: !1,
                isPlaying: !1,
                isDebugging: !1
            }), newPhase === "errored" && this.setState(storyId, {
                isLocked: !1,
                isPlaying: !1
            });
        }), this.channel.on((0, _coreEvents.SET_CURRENT_STORY), ()=>{
            this.initialized ? this.cleanup() : this.initialized = !0;
        });
        let start = ({ storyId, playUntil })=>{
            this.getState(storyId).isDebugging || this.setState(storyId, ({ calls })=>({
                    calls: [],
                    shadowCalls: calls.map((call)=>({
                            ...call,
                            status: "waiting"
                        })),
                    isDebugging: !0
                }));
            let log = this.getLog(storyId);
            this.setState(storyId, ({ shadowCalls })=>{
                if (playUntil || !log.length) return {
                    playUntil
                };
                let firstRowIndex = shadowCalls.findIndex((call)=>call.id === log[0].callId);
                return {
                    playUntil: shadowCalls.slice(0, firstRowIndex).filter((call)=>call.interceptable && !call.ancestors.length).slice(-1)[0]?.id
                };
            }), this.channel.emit((0, _coreEvents.FORCE_REMOUNT), {
                storyId,
                isDebugging: !0
            });
        }, back = ({ storyId })=>{
            let log = this.getLog(storyId).filter((call)=>!call.ancestors.length), last = log.reduceRight((res, item, index)=>res >= 0 || item.status === "waiting" ? res : index, -1);
            start({
                storyId,
                playUntil: log[last - 1]?.callId
            });
        }, goto = ({ storyId, callId })=>{
            let { calls, shadowCalls, resolvers } = this.getState(storyId), call = calls.find(({ id })=>id === callId), shadowCall = shadowCalls.find(({ id })=>id === callId);
            if (!call && shadowCall && Object.values(resolvers).length > 0) {
                let nextId = this.getLog(storyId).find((c)=>c.status === "waiting")?.callId;
                shadowCall.id !== nextId && this.setState(storyId, {
                    playUntil: shadowCall.id
                }), Object.values(resolvers).forEach((resolve)=>resolve());
            } else start({
                storyId,
                playUntil: callId
            });
        }, next = ({ storyId })=>{
            let { resolvers } = this.getState(storyId);
            if (Object.values(resolvers).length > 0) Object.values(resolvers).forEach((resolve)=>resolve());
            else {
                let nextId = this.getLog(storyId).find((c)=>c.status === "waiting")?.callId;
                nextId ? start({
                    storyId,
                    playUntil: nextId
                }) : end({
                    storyId
                });
            }
        }, end = ({ storyId })=>{
            this.setState(storyId, {
                playUntil: void 0,
                isDebugging: !1
            }), Object.values(this.getState(storyId).resolvers).forEach((resolve)=>resolve());
        };
        this.channel.on(EVENTS.START, start), this.channel.on(EVENTS.BACK, back), this.channel.on(EVENTS.GOTO, goto), this.channel.on(EVENTS.NEXT, next), this.channel.on(EVENTS.END, end);
    }
    getState(storyId) {
        return this.state[storyId] || getInitialState();
    }
    setState(storyId, update) {
        let state = this.getState(storyId), patch = typeof update == "function" ? update(state) : update;
        this.state = {
            ...this.state,
            [storyId]: {
                ...state,
                ...patch
            }
        }, (0, _global.global).window.parent.__STORYBOOK_ADDON_INTERACTIONS_INSTRUMENTER_STATE__ = this.state;
    }
    cleanup() {
        this.state = Object.entries(this.state).reduce((acc, [storyId, state])=>{
            let retainedState = getRetainedState(state);
            return retainedState && (acc[storyId] = Object.assign(getInitialState(), retainedState)), acc;
        }, {});
        let payload = {
            controlStates: controlsDisabled,
            logItems: []
        };
        this.channel.emit(EVENTS.SYNC, payload), (0, _global.global).window.parent.__STORYBOOK_ADDON_INTERACTIONS_INSTRUMENTER_STATE__ = this.state;
    }
    getLog(storyId) {
        let { calls, shadowCalls } = this.getState(storyId), merged = [
            ...shadowCalls
        ];
        calls.forEach((call, index)=>{
            merged[index] = call;
        });
        let seen2 = new Set;
        return merged.reduceRight((acc, call)=>(call.args.forEach((arg)=>{
                arg?.__callId__ && seen2.add(arg.__callId__);
            }), call.path.forEach((node)=>{
                node.__callId__ && seen2.add(node.__callId__);
            }), (call.interceptable || call.exception) && !seen2.has(call.id) && (acc.unshift({
                callId: call.id,
                status: call.status,
                ancestors: call.ancestors
            }), seen2.add(call.id)), acc), []);
    }
    instrument(obj, options, depth = 0) {
        if (!isInstrumentable(obj)) return obj;
        let { mutate = !1, path = [] } = options, keys = options.getKeys ? options.getKeys(obj, depth) : Object.keys(obj);
        return depth += 1, keys.reduce((acc, key)=>{
            let descriptor = getPropertyDescriptor(obj, key);
            if (typeof descriptor?.get == "function") {
                let getter = ()=>descriptor?.get?.bind(obj)?.();
                return Object.defineProperty(acc, key, {
                    get: ()=>this.instrument(getter(), {
                            ...options,
                            path: path.concat(key)
                        }, depth)
                }), acc;
            }
            let value = obj[key];
            return typeof value != "function" ? (acc[key] = this.instrument(value, {
                ...options,
                path: path.concat(key)
            }, depth), acc) : "__originalFn__" in value && typeof value.__originalFn__ == "function" ? (acc[key] = value, acc) : (acc[key] = (...args)=>this.track(key, value, obj, args, options), acc[key].__originalFn__ = value, Object.defineProperty(acc[key], "name", {
                value: key,
                writable: !1
            }), Object.keys(value).length > 0 && Object.assign(acc[key], this.instrument({
                ...value
            }, {
                ...options,
                path: path.concat(key)
            }, depth)), acc);
        }, mutate ? obj : construct(obj));
    }
    track(method, fn2, object, args, options) {
        let storyId = args?.[0]?.__storyId__ || (0, _global.global).__STORYBOOK_PREVIEW__?.selectionStore?.selection?.storyId, { cursor, ancestors } = this.getState(storyId);
        this.setState(storyId, {
            cursor: cursor + 1
        });
        let id = `${ancestors.slice(-1)[0] || storyId} [${cursor}] ${method}`, { path = [], intercept = !1, retain = !1 } = options, interceptable = typeof intercept == "function" ? intercept(method, path) : intercept, call = {
            id,
            cursor,
            storyId,
            ancestors,
            path,
            method,
            args,
            interceptable,
            retain
        }, result = (interceptable && !ancestors.length ? this.intercept : this.invoke).call(this, fn2, object, call, options);
        return this.instrument(result, {
            ...options,
            mutate: !0,
            path: [
                {
                    __callId__: call.id
                }
            ]
        });
    }
    intercept(fn2, object, call, options) {
        let { chainedCallIds, isDebugging, playUntil } = this.getState(call.storyId), isChainedUpon = chainedCallIds.has(call.id);
        return !isDebugging || isChainedUpon || playUntil ? (playUntil === call.id && this.setState(call.storyId, {
            playUntil: void 0
        }), this.invoke(fn2, object, call, options)) : new Promise((resolve)=>{
            this.setState(call.storyId, ({ resolvers })=>({
                    isLocked: !1,
                    resolvers: {
                        ...resolvers,
                        [call.id]: resolve
                    }
                }));
        }).then(()=>(this.setState(call.storyId, (state)=>{
                let { [call.id]: _, ...resolvers } = state.resolvers;
                return {
                    isLocked: !0,
                    resolvers
                };
            }), this.invoke(fn2, object, call, options)));
    }
    invoke(fn2, object, call, options) {
        let { callRefsByResult, renderPhase } = this.getState(call.storyId), serializeValues = (value)=>{
            if (callRefsByResult.has(value)) return callRefsByResult.get(value);
            if (value instanceof Array) return value.map(serializeValues);
            if (value instanceof Date) return {
                __date__: {
                    value: value.toISOString()
                }
            };
            if (value instanceof Error) {
                let { name, message, stack } = value;
                return {
                    __error__: {
                        name,
                        message,
                        stack
                    }
                };
            }
            if (value instanceof RegExp) {
                let { flags, source } = value;
                return {
                    __regexp__: {
                        flags,
                        source
                    }
                };
            }
            if (value instanceof (0, _global.global).window.HTMLElement) {
                let { prefix, localName, id, classList, innerText } = value, classNames = Array.from(classList);
                return {
                    __element__: {
                        prefix,
                        localName,
                        id,
                        classNames,
                        innerText
                    }
                };
            }
            return typeof value == "function" ? {
                __function__: {
                    name: value.name
                }
            } : typeof value == "symbol" ? {
                __symbol__: {
                    description: value.description
                }
            } : typeof value == "object" && value?.constructor?.name && value?.constructor?.name !== "Object" ? {
                __class__: {
                    name: value.constructor.name
                }
            } : Object.prototype.toString.call(value) === "[object Object]" ? Object.fromEntries(Object.entries(value).map(([key, val])=>[
                    key,
                    serializeValues(val)
                ])) : value;
        }, info = {
            ...call,
            args: call.args.map(serializeValues)
        };
        call.path.forEach((ref)=>{
            ref?.__callId__ && this.setState(call.storyId, ({ chainedCallIds })=>({
                    chainedCallIds: new Set(Array.from(chainedCallIds).concat(ref.__callId__))
                }));
        });
        let handleException = (e)=>{
            if (e instanceof Error) {
                let { name, message, stack, callId = call.id } = e, { showDiff, diff: diff2, actual, expected } = processError(e), exception = {
                    name,
                    message,
                    stack,
                    callId,
                    showDiff,
                    diff: diff2,
                    actual,
                    expected
                };
                if (this.update({
                    ...info,
                    status: "error",
                    exception
                }), this.setState(call.storyId, (state)=>({
                        callRefsByResult: new Map([
                            ...Array.from(state.callRefsByResult.entries()),
                            [
                                e,
                                {
                                    __callId__: call.id,
                                    retain: call.retain
                                }
                            ]
                        ])
                    })), call.ancestors.length) throw Object.prototype.hasOwnProperty.call(e, "callId") || Object.defineProperty(e, "callId", {
                    value: call.id
                }), e;
                if (e !== alreadyCompletedException) throw (0, _clientLogger.logger).warn(e), _coreEvents.IGNORED_EXCEPTION;
            }
            throw e;
        };
        try {
            if (renderPhase === "played" && !call.retain) throw alreadyCompletedException;
            let finalArgs = (options.getArgs ? options.getArgs(call, this.getState(call.storyId)) : call.args).map((arg)=>typeof arg != "function" || Object.keys(arg).length ? arg : (...args)=>{
                    let { cursor, ancestors } = this.getState(call.storyId);
                    this.setState(call.storyId, {
                        cursor: 0,
                        ancestors: [
                            ...ancestors,
                            call.id
                        ]
                    });
                    let restore = ()=>this.setState(call.storyId, {
                            cursor,
                            ancestors
                        }), willRestore = !1;
                    try {
                        let res = arg(...args);
                        return res instanceof Promise ? (willRestore = !0, res.finally(restore)) : res;
                    } finally{
                        willRestore || restore();
                    }
                }), result = fn2.apply(object, finalArgs);
            return result && [
                "object",
                "function",
                "symbol"
            ].includes(typeof result) && this.setState(call.storyId, (state)=>({
                    callRefsByResult: new Map([
                        ...Array.from(state.callRefsByResult.entries()),
                        [
                            result,
                            {
                                __callId__: call.id,
                                retain: call.retain
                            }
                        ]
                    ])
                })), this.update({
                ...info,
                status: result instanceof Promise ? "active" : "done"
            }), result instanceof Promise ? result.then((value)=>(this.update({
                    ...info,
                    status: "done"
                }), value), handleException) : result;
        } catch (e) {
            return handleException(e);
        }
    }
    update(call) {
        this.channel.emit(EVENTS.CALL, call), this.setState(call.storyId, ({ calls })=>{
            let callsById = calls.concat(call).reduce((a, c)=>Object.assign(a, {
                    [c.id]: c
                }), {});
            return {
                calls: Object.values(callsById).sort((a, b)=>a.id.localeCompare(b.id, void 0, {
                        numeric: !0
                    }))
            };
        }), this.sync(call.storyId);
    }
    sync(storyId) {
        let synchronize = ()=>{
            let { isLocked, isPlaying } = this.getState(storyId), logItems = this.getLog(storyId), pausedAt = logItems.filter(({ ancestors })=>!ancestors.length).find((item)=>item.status === "waiting")?.callId, hasActive = logItems.some((item)=>item.status === "active");
            if (isLocked || hasActive || logItems.length === 0) {
                let payload2 = {
                    controlStates: controlsDisabled,
                    logItems
                };
                this.channel.emit(EVENTS.SYNC, payload2);
                return;
            }
            let hasPrevious = logItems.some((item)=>item.status === "done" || item.status === "error"), payload = {
                controlStates: {
                    start: hasPrevious,
                    back: hasPrevious,
                    goto: !0,
                    next: isPlaying,
                    end: isPlaying
                },
                logItems,
                pausedAt
            };
            this.channel.emit(EVENTS.SYNC, payload);
        };
        this.setState(storyId, ({ syncTimeout })=>(clearTimeout(syncTimeout), {
                syncTimeout: setTimeout(synchronize, 0)
            }));
    }
};
function instrument(obj, options = {}) {
    try {
        let forceInstrument = !1, skipInstrument = !1;
        return (0, _global.global).window.location?.search?.includes("instrument=true") ? forceInstrument = !0 : (0, _global.global).window.location?.search?.includes("instrument=false") && (skipInstrument = !0), (0, _global.global).window.parent === (0, _global.global).window && !forceInstrument || skipInstrument ? obj : ((0, _global.global).window.__STORYBOOK_ADDON_INTERACTIONS_INSTRUMENTER__ || ((0, _global.global).window.__STORYBOOK_ADDON_INTERACTIONS_INSTRUMENTER__ = new Instrumenter), (0, _global.global).window.__STORYBOOK_ADDON_INTERACTIONS_INSTRUMENTER__.instrument(obj, options));
    } catch (e) {
        return (0, _clientLogger.once).warn(e), obj;
    }
}
function getPropertyDescriptor(obj, propName) {
    let target = obj;
    for(; target != null;){
        let descriptor = Object.getOwnPropertyDescriptor(target, propName);
        if (descriptor) return descriptor;
        target = Object.getPrototypeOf(target);
    }
}
var JestMock = new (0, _jestMock.ModuleMocker)((0, _global.global)), fn = JestMock.fn.bind(JestMock), { action } = instrument({
    action: fn
}, {
    retain: !0
}), channel = (0, _previewApi.addons).getChannel(), seen = new Set, spies = [];
channel.on((0, _coreEvents.FORCE_REMOUNT), ()=>spies.forEach((mock)=>mock?.mockClear?.()));
channel.on((0, _coreEvents.STORY_RENDER_PHASE_CHANGED), ({ newPhase })=>{
    newPhase === "loading" && spies.forEach((mock)=>mock?.mockClear?.());
});
var addSpies = (id, val, key)=>{
    if (seen.has(val)) return val;
    seen.add(val);
    try {
        if (Object.prototype.toString.call(val) === "[object Object]") {
            for (let [k, v] of Object.entries(val))val[k] = addSpies(id, v, k);
            return val;
        }
        if (Array.isArray(val)) return val.map((item, index)=>addSpies(id, item, `${key}[${index}]`));
        if (typeof val == "function" && val.isAction && !val._isMockFunction) {
            Object.defineProperty(val, "name", {
                value: key,
                writable: !1
            }), Object.defineProperty(val, "__storyId__", {
                value: id,
                writable: !1
            });
            let spy = action(val);
            return spies.push(spy), spy;
        }
    } catch  {}
    return val;
}, addActionsFromArgTypes = ({ id, initialArgs })=>addSpies(id, initialArgs), instrumentSpies = ({ initialArgs })=>Object.entries(initialArgs).filter(([, value])=>typeof value == "function" && "_isMockFunction" in value && value._isMockFunction && !value._instrumented).reduce((acc, [key, value])=>{
        let instrumented = instrument({
            [key]: ()=>value
        }, {
            retain: !0
        })[key];
        return acc[key] = instrumented(), value._instrumented = !0, acc;
    }, {}), argsEnhancers = [
    addActionsFromArgTypes,
    instrumentSpies
], { step: runStep } = instrument({
    step: (label, play, context)=>play(context)
}, {
    intercept: !0
}), parameters = {
    throwPlayFunctionExceptions: !1
};

},{"5da2f07b9fbb684":"84Hwt","c6663070f1932f32":"eG5no","@storybook/preview-api":"uDWyg","@storybook/global":"4g4co","@storybook/core-events":"ZHxpZ","@storybook/client-logger":"7OFBO","jest-mock":"e2G0L","@parcel/transformer-js/src/esmodule-helpers.js":"diccK"}],"84Hwt":[function(require,module,exports,__globalThis) {
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ 'use strict';
var base64 = require("9c62938f1dccc73c");
var ieee754 = require("aceacb6a4531a9d2");
var customInspectSymbol = typeof Symbol === 'function' && typeof Symbol.for === 'function' ? Symbol.for('nodejs.util.inspect.custom') : null;
exports.Buffer = Buffer;
exports.SlowBuffer = SlowBuffer;
exports.INSPECT_MAX_BYTES = 50;
var K_MAX_LENGTH = 0x7fffffff;
exports.kMaxLength = K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ Buffer.TYPED_ARRAY_SUPPORT = typedArraySupport();
if (!Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        var arr = new Uint8Array(1);
        var proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty(Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty(Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function createBuffer(length) {
    if (length > K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    var buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return allocUnsafe(arg);
    }
    return from(arg, encodingOrOffset, length);
}
Buffer.poolSize = 8192 // not used by this implementation
;
function from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return fromArrayLike(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if (isInstance(value, ArrayBuffer) || value && isInstance(value.buffer, ArrayBuffer)) return fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && (isInstance(value, SharedArrayBuffer) || value && isInstance(value.buffer, SharedArrayBuffer))) return fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    var valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return Buffer.from(valueOf, encodingOrOffset, length);
    var b = fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ Buffer.from = function(value, encodingOrOffset, length) {
    return from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf(Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf(Buffer, Uint8Array);
function assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function alloc(size, fill, encoding) {
    assertSize(size);
    if (size <= 0) return createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpretted as a start offset.
    return typeof encoding === 'string' ? createBuffer(size).fill(fill, encoding) : createBuffer(size).fill(fill);
    return createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ Buffer.alloc = function(size, fill, encoding) {
    return alloc(size, fill, encoding);
};
function allocUnsafe(size) {
    assertSize(size);
    return createBuffer(size < 0 ? 0 : checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ Buffer.allocUnsafe = function(size) {
    return allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ Buffer.allocUnsafeSlow = function(size) {
    return allocUnsafe(size);
};
function fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    var length = byteLength(string, encoding) | 0;
    var buf = createBuffer(length);
    var actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function fromArrayLike(array) {
    var length = array.length < 0 ? 0 : checked(array.length) | 0;
    var buf = createBuffer(length);
    for(var i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    var buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, Buffer.prototype);
    return buf;
}
function fromObject(obj) {
    if (Buffer.isBuffer(obj)) {
        var len = checked(obj.length) | 0;
        var buf = createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || numberIsNaN(obj.length)) return createBuffer(0);
        return fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return fromArrayLike(obj.data);
}
function checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function SlowBuffer(length) {
    if (+length != length) length = 0;
    return Buffer.alloc(+length);
}
Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
Buffer.compare = function compare(a, b) {
    if (isInstance(a, Uint8Array)) a = Buffer.from(a, a.offset, a.byteLength);
    if (isInstance(b, Uint8Array)) b = Buffer.from(b, b.offset, b.byteLength);
    if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    var x = a.length;
    var y = b.length;
    for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return Buffer.alloc(0);
    var i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    var buffer = Buffer.allocUnsafe(length);
    var pos = 0;
    for(i = 0; i < list.length; ++i){
        var buf = list[i];
        if (isInstance(buf, Uint8Array)) buf = Buffer.from(buf);
        if (!Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function byteLength(string, encoding) {
    if (Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    var len = string.length;
    var mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    var loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
Buffer.byteLength = byteLength;
function slowToString(encoding, start, end) {
    var loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return utf8Slice(this, start, end);
        case 'ascii':
            return asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return latin1Slice(this, start, end);
        case 'base64':
            return base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
Buffer.prototype._isBuffer = true;
function swap(b, n, m) {
    var i = b[n];
    b[n] = b[m];
    b[m] = i;
}
Buffer.prototype.swap16 = function swap16() {
    var len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(var i = 0; i < len; i += 2)swap(this, i, i + 1);
    return this;
};
Buffer.prototype.swap32 = function swap32() {
    var len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(var i = 0; i < len; i += 4){
        swap(this, i, i + 3);
        swap(this, i + 1, i + 2);
    }
    return this;
};
Buffer.prototype.swap64 = function swap64() {
    var len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(var i = 0; i < len; i += 8){
        swap(this, i, i + 7);
        swap(this, i + 1, i + 6);
        swap(this, i + 2, i + 5);
        swap(this, i + 3, i + 4);
    }
    return this;
};
Buffer.prototype.toString = function toString() {
    var length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return utf8Slice(this, 0, length);
    return slowToString.apply(this, arguments);
};
Buffer.prototype.toLocaleString = Buffer.prototype.toString;
Buffer.prototype.equals = function equals(b) {
    if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return Buffer.compare(this, b) === 0;
};
Buffer.prototype.inspect = function inspect() {
    var str = '';
    var max = exports.INSPECT_MAX_BYTES;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if (customInspectSymbol) Buffer.prototype[customInspectSymbol] = Buffer.prototype.inspect;
Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if (isInstance(target, Uint8Array)) target = Buffer.from(target, target.offset, target.byteLength);
    if (!Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    var x = thisEnd - thisStart;
    var y = end - start;
    var len = Math.min(x, y);
    var thisCopy = this.slice(thisStart, thisEnd);
    var targetCopy = target.slice(start, end);
    for(var i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if (numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if (Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    var indexSize = 1;
    var arrLength = arr.length;
    var valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    var i;
    if (dir) {
        var foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            var found = true;
            for(var j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    var remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    var strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    for(var i = 0; i < length; ++i){
        var parsed = parseInt(string.substr(i * 2, 2), 16);
        if (numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function utf8Write(buf, string, offset, length) {
    return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function asciiWrite(buf, string, offset, length) {
    return blitBuffer(asciiToBytes(string), buf, offset, length);
}
function latin1Write(buf, string, offset, length) {
    return asciiWrite(buf, string, offset, length);
}
function base64Write(buf, string, offset, length) {
    return blitBuffer(base64ToBytes(string), buf, offset, length);
}
function ucs2Write(buf, string, offset, length) {
    return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    var remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    var loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return utf8Write(this, string, offset, length);
        case 'ascii':
            return asciiWrite(this, string, offset, length);
        case 'latin1':
        case 'binary':
            return latin1Write(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return base64.fromByteArray(buf);
    else return base64.fromByteArray(buf.slice(start, end));
}
function utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    var res = [];
    var i = start;
    while(i < end){
        var firstByte = buf[i];
        var codePoint = null;
        var bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            var secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var MAX_ARGUMENTS_LENGTH = 0x1000;
function decodeCodePointsArray(codePoints) {
    var len = codePoints.length;
    if (len <= MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    var res = '';
    var i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH));
    return res;
}
function asciiSlice(buf, start, end) {
    var ret = '';
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function latin1Slice(buf, start, end) {
    var ret = '';
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function hexSlice(buf, start, end) {
    var len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    var out = '';
    for(var i = start; i < end; ++i)out += hexSliceLookupTable[buf[i]];
    return out;
}
function utf16leSlice(buf, start, end) {
    var bytes = buf.slice(start, end);
    var res = '';
    for(var i = 0; i < bytes.length; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
Buffer.prototype.slice = function slice(start, end) {
    var len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    var newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) checkOffset(offset, byteLength, this.length);
    var val = this[offset + --byteLength];
    var mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 1, this.length);
    return this[offset];
};
Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) checkOffset(offset, byteLength, this.length);
    var i = byteLength;
    var mul = 1;
    var val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 2, this.length);
    var val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 2, this.length);
    var val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 4, this.length);
    return ieee754.read(this, offset, true, 23, 4);
};
Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 4, this.length);
    return ieee754.read(this, offset, false, 23, 4);
};
Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 8, this.length);
    return ieee754.read(this, offset, true, 52, 8);
};
Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 8, this.length);
    return ieee754.read(this, offset, false, 52, 8);
};
function checkInt(buf, value, offset, ext, max, min) {
    if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var mul = 1;
    var i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var i = byteLength - 1;
    var mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = 0;
    var mul = 1;
    var sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = byteLength - 1;
    var mul = 1;
    var sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    ieee754.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return writeFloat(this, value, offset, true, noAssert);
};
Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return writeFloat(this, value, offset, false, noAssert);
};
function writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    ieee754.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return writeDouble(this, value, offset, true, noAssert);
};
Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    var len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else if (this === target && start < targetStart && targetStart < end) // descending copy from end
    for(var i = len - 1; i >= 0; --i)target[i + targetStart] = this[i + start];
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            var code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    var i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        var bytes = Buffer.isBuffer(val) ? val : Buffer.from(val, encoding);
        var len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// HELPER FUNCTIONS
// ================
var INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace(INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function utf8ToBytes(string, units) {
    units = units || Infinity;
    var codePoint;
    var length = string.length;
    var leadSurrogate = null;
    var bytes = [];
    for(var i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function asciiToBytes(str) {
    var byteArray = [];
    for(var i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function utf16leToBytes(str, units) {
    var c, hi, lo;
    var byteArray = [];
    for(var i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function base64ToBytes(str) {
    return base64.toByteArray(base64clean(str));
}
function blitBuffer(src, dst, offset, length) {
    for(var i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
var hexSliceLookupTable = function() {
    var alphabet = '0123456789abcdef';
    var table = new Array(256);
    for(var i = 0; i < 16; ++i){
        var i16 = i * 16;
        for(var j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();

},{"9c62938f1dccc73c":"8hlb9","aceacb6a4531a9d2":"j80rj"}],"8hlb9":[function(require,module,exports,__globalThis) {
'use strict';
exports.byteLength = byteLength;
exports.toByteArray = toByteArray;
exports.fromByteArray = fromByteArray;
var lookup = [];
var revLookup = [];
var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for(var i = 0, len = code.length; i < len; ++i){
    lookup[i] = code[i];
    revLookup[code.charCodeAt(i)] = i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
revLookup['-'.charCodeAt(0)] = 62;
revLookup['_'.charCodeAt(0)] = 63;
function getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf('=');
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function byteLength(b64) {
    var lens = getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function _byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function toByteArray(b64) {
    var tmp;
    var lens = getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = revLookup[b64.charCodeAt(i)] << 18 | revLookup[b64.charCodeAt(i + 1)] << 12 | revLookup[b64.charCodeAt(i + 2)] << 6 | revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = revLookup[b64.charCodeAt(i)] << 2 | revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = revLookup[b64.charCodeAt(i)] << 10 | revLookup[b64.charCodeAt(i + 1)] << 4 | revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function tripletToBase64(num) {
    return lookup[num >> 18 & 0x3F] + lookup[num >> 12 & 0x3F] + lookup[num >> 6 & 0x3F] + lookup[num & 0x3F];
}
function encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push(tripletToBase64(tmp));
    }
    return output.join('');
}
function fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push(encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push(lookup[tmp >> 2] + lookup[tmp << 4 & 0x3F] + '==');
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push(lookup[tmp >> 10] + lookup[tmp >> 4 & 0x3F] + lookup[tmp << 2 & 0x3F] + '=');
    }
    return parts.join('');
}

},{}],"j80rj":[function(require,module,exports,__globalThis) {
exports.read = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
exports.write = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

},{}],"eG5no":[function(require,module,exports,__globalThis) {
// shim for using process in browser
var process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var cachedSetTimeout;
var cachedClearTimeout;
function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
}
(function() {
    try {
        if (typeof setTimeout === 'function') cachedSetTimeout = setTimeout;
        else cachedSetTimeout = defaultSetTimout;
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') cachedClearTimeout = clearTimeout;
        else cachedClearTimeout = defaultClearTimeout;
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
})();
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }
}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;
function cleanUpNextTick() {
    if (!draining || !currentQueue) return;
    draining = false;
    if (currentQueue.length) queue = currentQueue.concat(queue);
    else queueIndex = -1;
    if (queue.length) drainQueue();
}
function drainQueue() {
    if (draining) return;
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;
    var len = queue.length;
    while(len){
        currentQueue = queue;
        queue = [];
        while(++queueIndex < len)if (currentQueue) currentQueue[queueIndex].run();
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}
process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) runTimeout(drainQueue);
};
// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};
function noop() {}
process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;
process.listeners = function(name) {
    return [];
};
process.binding = function(name) {
    throw new Error('process.binding is not supported');
};
process.cwd = function() {
    return '/';
};
process.chdir = function(dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() {
    return 0;
};

},{}],"e2G0L":[function(require,module,exports,__globalThis) {
var global = arguments[3];
'use strict';
Object.defineProperty(exports, '__esModule', {
    value: true
});
exports.spyOn = exports.mocked = exports.fn = exports.ModuleMocker = void 0;
function _defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
/**
 * Copyright (c) Facebook, Inc. and its affiliates. All Rights Reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /* eslint-disable local/ban-types-eventually, local/prefer-rest-params-eventually */ /**
 * Possible types of a MockFunctionResult.
 * 'return': The call completed by returning normally.
 * 'throw': The call completed by throwing a value.
 * 'incomplete': The call has not completed yet. This is possible if you read
 *               the  mock function result from within the mock function itself
 *               (or a function called by the mock function).
 */ /**
 * Represents the result of a single call to a mock function.
 */ // see https://github.com/Microsoft/TypeScript/issues/25215
const MOCK_CONSTRUCTOR_NAME = 'mockConstructor';
const FUNCTION_NAME_RESERVED_PATTERN = /[\s!-\/:-@\[-`{-~]/;
const FUNCTION_NAME_RESERVED_REPLACE = new RegExp(FUNCTION_NAME_RESERVED_PATTERN.source, 'g');
const RESERVED_KEYWORDS = new Set([
    'arguments',
    'await',
    'break',
    'case',
    'catch',
    'class',
    'const',
    'continue',
    'debugger',
    'default',
    'delete',
    'do',
    'else',
    'enum',
    'eval',
    'export',
    'extends',
    'false',
    'finally',
    'for',
    'function',
    'if',
    'implements',
    'import',
    'in',
    'instanceof',
    'interface',
    'let',
    'new',
    'null',
    'package',
    'private',
    'protected',
    'public',
    'return',
    'static',
    'super',
    'switch',
    'this',
    'throw',
    'true',
    'try',
    'typeof',
    'var',
    'void',
    'while',
    'with',
    'yield'
]);
function matchArity(fn, length) {
    let mockConstructor;
    switch(length){
        case 1:
            mockConstructor = function(_a) {
                return fn.apply(this, arguments);
            };
            break;
        case 2:
            mockConstructor = function(_a, _b) {
                return fn.apply(this, arguments);
            };
            break;
        case 3:
            mockConstructor = function(_a, _b, _c) {
                return fn.apply(this, arguments);
            };
            break;
        case 4:
            mockConstructor = function(_a, _b, _c, _d) {
                return fn.apply(this, arguments);
            };
            break;
        case 5:
            mockConstructor = function(_a, _b, _c, _d, _e) {
                return fn.apply(this, arguments);
            };
            break;
        case 6:
            mockConstructor = function(_a, _b, _c, _d, _e, _f) {
                return fn.apply(this, arguments);
            };
            break;
        case 7:
            mockConstructor = function(_a, _b, _c, _d, _e, _f, _g) {
                return fn.apply(this, arguments);
            };
            break;
        case 8:
            mockConstructor = function(_a, _b, _c, _d, _e, _f, _g, _h) {
                return fn.apply(this, arguments);
            };
            break;
        case 9:
            mockConstructor = function(_a, _b, _c, _d, _e, _f, _g, _h, _i) {
                return fn.apply(this, arguments);
            };
            break;
        default:
            mockConstructor = function() {
                return fn.apply(this, arguments);
            };
            break;
    }
    return mockConstructor;
}
function getObjectType(value) {
    return Object.prototype.toString.apply(value).slice(8, -1);
}
function getType(ref) {
    const typeName = getObjectType(ref);
    if (typeName === 'Function' || typeName === 'AsyncFunction' || typeName === 'GeneratorFunction') return 'function';
    else if (Array.isArray(ref)) return 'array';
    else if (typeName === 'Object') return 'object';
    else if (typeName === 'Number' || typeName === 'String' || typeName === 'Boolean' || typeName === 'Symbol') return 'constant';
    else if (typeName === 'Map' || typeName === 'WeakMap' || typeName === 'Set') return 'collection';
    else if (typeName === 'RegExp') return 'regexp';
    else if (ref === undefined) return 'undefined';
    else if (ref === null) return 'null';
    else return null;
}
function isReadonlyProp(object, prop) {
    if (prop === 'arguments' || prop === 'caller' || prop === 'callee' || prop === 'name' || prop === 'length') {
        const typeName = getObjectType(object);
        return typeName === 'Function' || typeName === 'AsyncFunction' || typeName === 'GeneratorFunction';
    }
    if (prop === 'source' || prop === 'global' || prop === 'ignoreCase' || prop === 'multiline') return getObjectType(object) === 'RegExp';
    return false;
}
class ModuleMocker {
    /**
   * @see README.md
   * @param global Global object of the test environment, used to create
   * mocks
   */ constructor(global){
        _defineProperty(this, '_environmentGlobal', void 0);
        _defineProperty(this, '_mockState', void 0);
        _defineProperty(this, '_mockConfigRegistry', void 0);
        _defineProperty(this, '_spyState', void 0);
        _defineProperty(this, '_invocationCallCounter', void 0);
        this._environmentGlobal = global;
        this._mockState = new WeakMap();
        this._mockConfigRegistry = new WeakMap();
        this._spyState = new Set();
        this._invocationCallCounter = 1;
    }
    _getSlots(object) {
        if (!object) return [];
        const slots = new Set();
        const EnvObjectProto = this._environmentGlobal.Object.prototype;
        const EnvFunctionProto = this._environmentGlobal.Function.prototype;
        const EnvRegExpProto = this._environmentGlobal.RegExp.prototype; // Also check the builtins in the current context as they leak through
        // core node modules.
        const ObjectProto = Object.prototype;
        const FunctionProto = Function.prototype;
        const RegExpProto = RegExp.prototype; // Properties of Object.prototype, Function.prototype and RegExp.prototype
        // are never reported as slots
        while(object != null && object !== EnvObjectProto && object !== EnvFunctionProto && object !== EnvRegExpProto && object !== ObjectProto && object !== FunctionProto && object !== RegExpProto){
            const ownNames = Object.getOwnPropertyNames(object);
            for(let i = 0; i < ownNames.length; i++){
                const prop = ownNames[i];
                if (!isReadonlyProp(object, prop)) {
                    const propDesc = Object.getOwnPropertyDescriptor(object, prop);
                    if (propDesc !== undefined && !propDesc.get || object.__esModule) slots.add(prop);
                }
            }
            object = Object.getPrototypeOf(object);
        }
        return Array.from(slots);
    }
    _ensureMockConfig(f) {
        let config = this._mockConfigRegistry.get(f);
        if (!config) {
            config = this._defaultMockConfig();
            this._mockConfigRegistry.set(f, config);
        }
        return config;
    }
    _ensureMockState(f) {
        let state = this._mockState.get(f);
        if (!state) {
            state = this._defaultMockState();
            this._mockState.set(f, state);
        }
        if (state.calls.length > 0) state.lastCall = state.calls[state.calls.length - 1];
        return state;
    }
    _defaultMockConfig() {
        return {
            mockImpl: undefined,
            mockName: 'jest.fn()',
            specificMockImpls: [],
            specificReturnValues: []
        };
    }
    _defaultMockState() {
        return {
            calls: [],
            instances: [],
            invocationCallOrder: [],
            results: []
        };
    }
    _makeComponent(metadata, restore) {
        if (metadata.type === 'object') return new this._environmentGlobal.Object();
        else if (metadata.type === 'array') return new this._environmentGlobal.Array();
        else if (metadata.type === 'regexp') return new this._environmentGlobal.RegExp('');
        else if (metadata.type === 'constant' || metadata.type === 'collection' || metadata.type === 'null' || metadata.type === 'undefined') return metadata.value;
        else if (metadata.type === 'function') {
            const prototype = metadata.members && metadata.members.prototype && metadata.members.prototype.members || {};
            const prototypeSlots = this._getSlots(prototype);
            const mocker = this;
            const mockConstructor = matchArity(function(...args) {
                const mockState = mocker._ensureMockState(f);
                const mockConfig = mocker._ensureMockConfig(f);
                mockState.instances.push(this);
                mockState.calls.push(args); // Create and record an "incomplete" mock result immediately upon
                // calling rather than waiting for the mock to return. This avoids
                // issues caused by recursion where results can be recorded in the
                // wrong order.
                const mockResult = {
                    type: 'incomplete',
                    value: undefined
                };
                mockState.results.push(mockResult);
                mockState.invocationCallOrder.push(mocker._invocationCallCounter++); // Will be set to the return value of the mock if an error is not thrown
                let finalReturnValue; // Will be set to the error that is thrown by the mock (if it throws)
                let thrownError; // Will be set to true if the mock throws an error. The presence of a
                // value in `thrownError` is not a 100% reliable indicator because a
                // function could throw a value of undefined.
                let callDidThrowError = false;
                try {
                    // The bulk of the implementation is wrapped in an immediately
                    // executed arrow function so the return value of the mock function
                    // can be easily captured and recorded, despite the many separate
                    // return points within the logic.
                    finalReturnValue = (()=>{
                        if (this instanceof f) {
                            // This is probably being called as a constructor
                            prototypeSlots.forEach((slot)=>{
                                // Copy prototype methods to the instance to make
                                // it easier to interact with mock instance call and
                                // return values
                                if (prototype[slot].type === 'function') {
                                    // @ts-expect-error no index signature
                                    const protoImpl = this[slot]; // @ts-expect-error no index signature
                                    this[slot] = mocker.generateFromMetadata(prototype[slot]); // @ts-expect-error no index signature
                                    this[slot]._protoImpl = protoImpl;
                                }
                            }); // Run the mock constructor implementation
                            const mockImpl = mockConfig.specificMockImpls.length ? mockConfig.specificMockImpls.shift() : mockConfig.mockImpl;
                            return mockImpl && mockImpl.apply(this, arguments);
                        } // If mockImplementationOnce()/mockImplementation() is last set,
                        // implementation use the mock
                        let specificMockImpl = mockConfig.specificMockImpls.shift();
                        if (specificMockImpl === undefined) specificMockImpl = mockConfig.mockImpl;
                        if (specificMockImpl) return specificMockImpl.apply(this, arguments);
                         // Otherwise use prototype implementation
                        if (f._protoImpl) return f._protoImpl.apply(this, arguments);
                        return undefined;
                    })();
                } catch (error) {
                    // Store the thrown error so we can record it, then re-throw it.
                    thrownError = error;
                    callDidThrowError = true;
                    throw error;
                } finally{
                    // Record the result of the function.
                    // NOTE: Intentionally NOT pushing/indexing into the array of mock
                    //       results here to avoid corrupting results data if mockClear()
                    //       is called during the execution of the mock.
                    mockResult.type = callDidThrowError ? 'throw' : 'return';
                    mockResult.value = callDidThrowError ? thrownError : finalReturnValue;
                }
                return finalReturnValue;
            }, metadata.length || 0);
            const f = this._createMockFunction(metadata, mockConstructor);
            f._isMockFunction = true;
            f.getMockImplementation = ()=>this._ensureMockConfig(f).mockImpl;
            if (typeof restore === 'function') this._spyState.add(restore);
            this._mockState.set(f, this._defaultMockState());
            this._mockConfigRegistry.set(f, this._defaultMockConfig());
            Object.defineProperty(f, 'mock', {
                configurable: false,
                enumerable: true,
                get: ()=>this._ensureMockState(f),
                set: (val)=>this._mockState.set(f, val)
            });
            f.mockClear = ()=>{
                this._mockState.delete(f);
                return f;
            };
            f.mockReset = ()=>{
                f.mockClear();
                this._mockConfigRegistry.delete(f);
                return f;
            };
            f.mockRestore = ()=>{
                f.mockReset();
                return restore ? restore() : undefined;
            };
            f.mockReturnValueOnce = (value // next function call will return this value or default return value
            )=>f.mockImplementationOnce(()=>value);
            f.mockResolvedValueOnce = (value)=>f.mockImplementationOnce(()=>Promise.resolve(value));
            f.mockRejectedValueOnce = (value)=>f.mockImplementationOnce(()=>Promise.reject(value));
            f.mockReturnValue = (value // next function call will return specified return value or this one
            )=>f.mockImplementation(()=>value);
            f.mockResolvedValue = (value)=>f.mockImplementation(()=>Promise.resolve(value));
            f.mockRejectedValue = (value)=>f.mockImplementation(()=>Promise.reject(value));
            f.mockImplementationOnce = (fn)=>{
                // next function call will use this mock implementation return value
                // or default mock implementation return value
                const mockConfig = this._ensureMockConfig(f);
                mockConfig.specificMockImpls.push(fn);
                return f;
            };
            f.mockImplementation = (fn)=>{
                // next function call will use mock implementation return value
                const mockConfig = this._ensureMockConfig(f);
                mockConfig.mockImpl = fn;
                return f;
            };
            f.mockReturnThis = ()=>f.mockImplementation(function() {
                    return this;
                });
            f.mockName = (name)=>{
                if (name) {
                    const mockConfig = this._ensureMockConfig(f);
                    mockConfig.mockName = name;
                }
                return f;
            };
            f.getMockName = ()=>{
                const mockConfig = this._ensureMockConfig(f);
                return mockConfig.mockName || 'jest.fn()';
            };
            if (metadata.mockImpl) f.mockImplementation(metadata.mockImpl);
            return f;
        } else {
            const unknownType = metadata.type || 'undefined type';
            throw new Error('Unrecognized type ' + unknownType);
        }
    }
    _createMockFunction(metadata, mockConstructor) {
        let name = metadata.name;
        if (!name) return mockConstructor;
         // Preserve `name` property of mocked function.
        const boundFunctionPrefix = 'bound ';
        let bindCall = ''; // if-do-while for perf reasons. The common case is for the if to fail.
        if (name && name.startsWith(boundFunctionPrefix)) do {
            name = name.substring(boundFunctionPrefix.length); // Call bind() just to alter the function name.
            bindCall = '.bind(null)';
        }while (name && name.startsWith(boundFunctionPrefix));
         // Special case functions named `mockConstructor` to guard for infinite
        // loops.
        if (name === MOCK_CONSTRUCTOR_NAME) return mockConstructor;
        if (// It's a syntax error to define functions with a reserved keyword
        // as name.
        RESERVED_KEYWORDS.has(name) || // It's also a syntax error to define functions with a name that starts with a number
        /^\d/.test(name)) name = '$' + name;
         // It's also a syntax error to define a function with a reserved character
        // as part of it's name.
        if (FUNCTION_NAME_RESERVED_PATTERN.test(name)) name = name.replace(FUNCTION_NAME_RESERVED_REPLACE, '$');
        const body = 'return function ' + name + '() {' + 'return ' + MOCK_CONSTRUCTOR_NAME + '.apply(this,arguments);' + '}' + bindCall;
        const createConstructor = new this._environmentGlobal.Function(MOCK_CONSTRUCTOR_NAME, body);
        return createConstructor(mockConstructor);
    }
    _generateMock(metadata, callbacks, refs) {
        // metadata not compatible but it's the same type, maybe problem with
        // overloading of _makeComponent and not _generateMock?
        // @ts-expect-error
        const mock = this._makeComponent(metadata);
        if (metadata.refID != null) refs[metadata.refID] = mock;
        this._getSlots(metadata.members).forEach((slot)=>{
            const slotMetadata = metadata.members && metadata.members[slot] || {};
            if (slotMetadata.ref != null) callbacks.push(function(ref) {
                return ()=>mock[slot] = refs[ref];
            }(slotMetadata.ref));
            else mock[slot] = this._generateMock(slotMetadata, callbacks, refs);
        });
        if (metadata.type !== 'undefined' && metadata.type !== 'null' && mock.prototype && typeof mock.prototype === 'object') mock.prototype.constructor = mock;
        return mock;
    }
    /**
   * @see README.md
   * @param _metadata Metadata for the mock in the schema returned by the
   * getMetadata method of this module.
   */ generateFromMetadata(_metadata) {
        const callbacks = [];
        const refs = {};
        const mock = this._generateMock(_metadata, callbacks, refs);
        callbacks.forEach((setter)=>setter());
        return mock;
    }
    /**
   * @see README.md
   * @param component The component for which to retrieve metadata.
   */ getMetadata(component, _refs) {
        const refs = _refs || new Map();
        const ref = refs.get(component);
        if (ref != null) return {
            ref
        };
        const type = getType(component);
        if (!type) return null;
        const metadata = {
            type
        };
        if (type === 'constant' || type === 'collection' || type === 'undefined' || type === 'null') {
            metadata.value = component;
            return metadata;
        } else if (type === 'function') {
            // @ts-expect-error this is a function so it has a name
            metadata.name = component.name; // @ts-expect-error may be a mock
            if (component._isMockFunction === true) // @ts-expect-error may be a mock
            metadata.mockImpl = component.getMockImplementation();
        }
        metadata.refID = refs.size;
        refs.set(component, metadata.refID);
        let members = null; // Leave arrays alone
        if (type !== 'array') this._getSlots(component).forEach((slot)=>{
            if (type === 'function' && // @ts-expect-error may be a mock
            component._isMockFunction === true && slot.match(/^mock/)) return;
             // @ts-expect-error no index signature
            const slotMetadata = this.getMetadata(component[slot], refs);
            if (slotMetadata) {
                if (!members) members = {};
                members[slot] = slotMetadata;
            }
        });
        if (members) metadata.members = members;
        return metadata;
    }
    isMockFunction(fn) {
        return !!fn && fn._isMockFunction === true;
    }
    fn(implementation) {
        const length = implementation ? implementation.length : 0;
        const fn = this._makeComponent({
            length,
            type: 'function'
        });
        if (implementation) fn.mockImplementation(implementation);
        return fn;
    }
    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
    spyOn(object, methodName, accessType) {
        if (accessType) return this._spyOnProperty(object, methodName, accessType);
        if (typeof object !== 'object' && typeof object !== 'function') throw new Error('Cannot spyOn on a primitive value; ' + this._typeOf(object) + ' given');
        const original = object[methodName];
        if (!this.isMockFunction(original)) {
            if (typeof original !== 'function') throw new Error('Cannot spy the ' + methodName + ' property because it is not a function; ' + this._typeOf(original) + ' given instead');
            const isMethodOwner = Object.prototype.hasOwnProperty.call(object, methodName);
            let descriptor = Object.getOwnPropertyDescriptor(object, methodName);
            let proto = Object.getPrototypeOf(object);
            while(!descriptor && proto !== null){
                descriptor = Object.getOwnPropertyDescriptor(proto, methodName);
                proto = Object.getPrototypeOf(proto);
            }
            let mock;
            if (descriptor && descriptor.get) {
                const originalGet = descriptor.get;
                mock = this._makeComponent({
                    type: 'function'
                }, ()=>{
                    descriptor.get = originalGet;
                    Object.defineProperty(object, methodName, descriptor);
                });
                descriptor.get = ()=>mock;
                Object.defineProperty(object, methodName, descriptor);
            } else {
                mock = this._makeComponent({
                    type: 'function'
                }, ()=>{
                    if (isMethodOwner) object[methodName] = original;
                    else delete object[methodName];
                }); // @ts-expect-error overriding original method with a Mock
                object[methodName] = mock;
            }
            mock.mockImplementation(function() {
                return original.apply(this, arguments);
            });
        }
        return object[methodName];
    }
    _spyOnProperty(obj, propertyName, accessType = 'get') {
        if (typeof obj !== 'object' && typeof obj !== 'function') throw new Error('Cannot spyOn on a primitive value; ' + this._typeOf(obj) + ' given');
        if (!obj) throw new Error('spyOn could not find an object to spy upon for ' + propertyName + '');
        if (!propertyName) throw new Error('No property name supplied');
        let descriptor = Object.getOwnPropertyDescriptor(obj, propertyName);
        let proto = Object.getPrototypeOf(obj);
        while(!descriptor && proto !== null){
            descriptor = Object.getOwnPropertyDescriptor(proto, propertyName);
            proto = Object.getPrototypeOf(proto);
        }
        if (!descriptor) throw new Error(propertyName + ' property does not exist');
        if (!descriptor.configurable) throw new Error(propertyName + ' is not declared configurable');
        if (!descriptor[accessType]) throw new Error('Property ' + propertyName + ' does not have access type ' + accessType);
        const original = descriptor[accessType];
        if (!this.isMockFunction(original)) {
            if (typeof original !== 'function') throw new Error('Cannot spy the ' + propertyName + ' property because it is not a function; ' + this._typeOf(original) + ' given instead');
             // @ts-expect-error: mock is assignable
            descriptor[accessType] = this._makeComponent({
                type: 'function'
            }, ()=>{
                // @ts-expect-error: mock is assignable
                descriptor[accessType] = original;
                Object.defineProperty(obj, propertyName, descriptor);
            });
            descriptor[accessType].mockImplementation(function() {
                // @ts-expect-error
                return original.apply(this, arguments);
            });
        }
        Object.defineProperty(obj, propertyName, descriptor);
        return descriptor[accessType];
    }
    clearAllMocks() {
        this._mockState = new WeakMap();
    }
    resetAllMocks() {
        this._mockConfigRegistry = new WeakMap();
        this._mockState = new WeakMap();
    }
    restoreAllMocks() {
        this._spyState.forEach((restore)=>restore());
        this._spyState = new Set();
    }
    _typeOf(value) {
        return value == null ? '' + value : typeof value;
    }
    mocked(item, _deep = false) {
        return item;
    }
}
exports.ModuleMocker = ModuleMocker;
const JestMock = new ModuleMocker(global);
const fn = JestMock.fn.bind(JestMock);
exports.fn = fn;
const spyOn = JestMock.spyOn.bind(JestMock);
exports.spyOn = spyOn;
const mocked = JestMock.mocked.bind(JestMock);
exports.mocked = mocked;

},{}]},[], null, "parcelRequire94c2")

//# sourceMappingURL=preview.182751ca.js.map
